import "core-js/modules/es.promise.finally.js";
import "core-js/modules/esnext.global-this.js";
import React, { createContext, useState, useReducer, useRef, useEffect, useCallback, useMemo, useContext } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var _extendStatics = function extendStatics(d, b) {
  _extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
  };
  return _extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  _extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
var _e2 = function e(t, n) {
  return _e2 = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, t) {
    e.__proto__ = t;
  } || function (e, t) {
    for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
  }, _e2(t, n);
};
function t(t, n) {
  if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
  function r() {
    this.constructor = t;
  }
  _e2(t, n), t.prototype = null === n ? Object.create(n) : (r.prototype = n.prototype, new r());
}
var _n2 = function n() {
  return _n2 = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    return e;
  }, _n2.apply(this, arguments);
};
function r(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
    var o = 0;
    for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  }
  return n;
}
function o(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function c(e) {
      try {
        s(r.next(e));
      } catch (e) {
        i(e);
      }
    }
    function a(e) {
      try {
        s(r.throw(e));
      } catch (e) {
        i(e);
      }
    }
    function s(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof n ? t : new n(function (e) {
        e(t);
      })).then(c, a);
    }
    s((r = r.apply(e, t || [])).next());
  });
}
function i(e, t) {
  var n,
    r,
    o,
    i,
    c = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
  return i = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;
  function a(i) {
    return function (a) {
      return function (i) {
        if (n) throw new TypeError("Generator is already executing.");
        for (; c;) try {
          if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
          switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
            case 0:
            case 1:
              o = i;
              break;
            case 4:
              return c.label++, {
                value: i[1],
                done: !1
              };
            case 5:
              c.label++, r = i[1], i = [0];
              continue;
            case 7:
              i = c.ops.pop(), c.trys.pop();
              continue;
            default:
              if (!(o = c.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                c = 0;
                continue;
              }
              if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                c.label = i[1];
                break;
              }
              if (6 === i[0] && c.label < o[1]) {
                c.label = o[1], o = i;
                break;
              }
              if (o && c.label < o[2]) {
                c.label = o[2], c.ops.push(i);
                break;
              }
              o[2] && c.ops.pop(), c.trys.pop();
              continue;
          }
          i = t.call(e, c);
        } catch (e) {
          i = [6, e], r = 0;
        } finally {
          n = o = 0;
        }
        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, a]);
    };
  }
}
function c(e, t) {
  var n = "function" == typeof Symbol && e[Symbol.iterator];
  if (!n) return e;
  var r,
    o,
    i = n.call(e),
    c = [];
  try {
    for (; (void 0 === t || t-- > 0) && !(r = i.next()).done;) c.push(r.value);
  } catch (e) {
    o = {
      error: e
    };
  } finally {
    try {
      r && !r.done && (n = i.return) && n.call(i);
    } finally {
      if (o) throw o.error;
    }
  }
  return c;
}
function a(e, t, n) {
  if (n || 2 === arguments.length) for (var r, o = 0, i = t.length; o < i; o++) !r && o in t || (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var s = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function u(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function l(e, t) {
  return e(t = {
    exports: {}
  }, t.exports), t.exports;
}
var f,
  d,
  h = function h(e) {
    return e && e.Math == Math && e;
  },
  p = h("object" == typeof globalThis && globalThis) || h("object" == typeof window && window) || h("object" == typeof self && self) || h("object" == typeof s && s) || function () {
    return this;
  }() || Function("return this")(),
  y = function y(e) {
    try {
      return !!e();
    } catch (e) {
      return !0;
    }
  },
  v = !y(function () {
    return 7 != Object.defineProperty({}, 1, {
      get: function get() {
        return 7;
      }
    })[1];
  }),
  m = !y(function () {
    var e = function () {}.bind();
    return "function" != typeof e || e.hasOwnProperty("prototype");
  }),
  b = Function.prototype.call,
  g = m ? b.bind(b) : function () {
    return b.apply(b, arguments);
  },
  w = {}.propertyIsEnumerable,
  S = Object.getOwnPropertyDescriptor,
  k = S && !w.call({
    1: 2
  }, 1) ? function (e) {
    var t = S(this, e);
    return !!t && t.enumerable;
  } : w,
  _ = {
    f: k
  },
  I = function I(e, t) {
    return {
      enumerable: !(1 & e),
      configurable: !(2 & e),
      writable: !(4 & e),
      value: t
    };
  },
  O = Function,
  x = O.prototype,
  T = x.bind,
  C = x.call,
  j = m && T.bind(C, C),
  L = function L(e) {
    return e instanceof O ? m ? j(e) : function () {
      return C.apply(e, arguments);
    } : void 0;
  },
  R = L({}.toString),
  W = L("".slice),
  Z = function Z(e) {
    return W(R(e), 8, -1);
  },
  E = Object,
  G = L("".split),
  A = y(function () {
    return !E("z").propertyIsEnumerable(0);
  }) ? function (e) {
    return "String" == Z(e) ? G(e, "") : E(e);
  } : E,
  P = function P(e) {
    return null == e;
  },
  X = TypeError,
  F = function F(e) {
    if (P(e)) throw X("Can't call method on " + e);
    return e;
  },
  K = function K(e) {
    return A(F(e));
  },
  N = "object" == typeof document && document.all,
  U = {
    all: N,
    IS_HTMLDDA: void 0 === N && void 0 !== N
  },
  D = U.all,
  H = U.IS_HTMLDDA ? function (e) {
    return "function" == typeof e || e === D;
  } : function (e) {
    return "function" == typeof e;
  },
  Y = U.all,
  J = U.IS_HTMLDDA ? function (e) {
    return "object" == typeof e ? null !== e : H(e) || e === Y;
  } : function (e) {
    return "object" == typeof e ? null !== e : H(e);
  },
  V = function V(e) {
    return H(e) ? e : void 0;
  },
  z = function z(e, t) {
    return arguments.length < 2 ? V(p[e]) : p[e] && p[e][t];
  },
  M = L({}.isPrototypeOf),
  B = z("navigator", "userAgent") || "",
  Q = p.process,
  q = p.Deno,
  $ = Q && Q.versions || q && q.version,
  ee = $ && $.v8;
ee && (d = (f = ee.split("."))[0] > 0 && f[0] < 4 ? 1 : +(f[0] + f[1])), !d && B && (!(f = B.match(/Edge\/(\d+)/)) || f[1] >= 74) && (f = B.match(/Chrome\/(\d+)/)) && (d = +f[1]);
var te = d,
  ne = !!Object.getOwnPropertySymbols && !y(function () {
    var e = Symbol();
    return !String(e) || !(Object(e) instanceof Symbol) || !Symbol.sham && te && te < 41;
  }),
  re = ne && !Symbol.sham && "symbol" == typeof Symbol.iterator,
  oe = Object,
  ie = re ? function (e) {
    return "symbol" == typeof e;
  } : function (e) {
    var t = z("Symbol");
    return H(t) && M(t.prototype, oe(e));
  },
  ce = String,
  ae = function ae(e) {
    try {
      return ce(e);
    } catch (e) {
      return "Object";
    }
  },
  se = TypeError,
  ue = function ue(e) {
    if (H(e)) return e;
    throw se(ae(e) + " is not a function");
  },
  le = function le(e, t) {
    var n = e[t];
    return P(n) ? void 0 : ue(n);
  },
  fe = TypeError,
  de = Object.defineProperty,
  he = function he(e, t) {
    try {
      de(p, e, {
        value: t,
        configurable: !0,
        writable: !0
      });
    } catch (n) {
      p[e] = t;
    }
    return t;
  },
  pe = p["__core-js_shared__"] || he("__core-js_shared__", {}),
  ye = l(function (e) {
    (e.exports = function (e, t) {
      return pe[e] || (pe[e] = void 0 !== t ? t : {});
    })("versions", []).push({
      version: "3.25.4",
      mode: "global",
      copyright: "© 2014-2022 Denis Pushkarev (zloirock.ru)",
      license: "https://github.com/zloirock/core-js/blob/v3.25.4/LICENSE",
      source: "https://github.com/zloirock/core-js"
    });
  }),
  ve = Object,
  me = function me(e) {
    return ve(F(e));
  },
  be = L({}.hasOwnProperty),
  ge = Object.hasOwn || function (e, t) {
    return be(me(e), t);
  },
  we = 0,
  Se = Math.random(),
  ke = L(1..toString),
  _e = function _e(e) {
    return "Symbol(" + (void 0 === e ? "" : e) + ")_" + ke(++we + Se, 36);
  },
  Ie = ye("wks"),
  Oe = p.Symbol,
  xe = Oe && Oe.for,
  Te = re ? Oe : Oe && Oe.withoutSetter || _e,
  Ce = function Ce(e) {
    if (!ge(Ie, e) || !ne && "string" != typeof Ie[e]) {
      var t = "Symbol." + e;
      ne && ge(Oe, e) ? Ie[e] = Oe[e] : Ie[e] = re && xe ? xe(t) : Te(t);
    }
    return Ie[e];
  },
  je = TypeError,
  Le = Ce("toPrimitive"),
  Re = function Re(e, t) {
    if (!J(e) || ie(e)) return e;
    var n,
      r = le(e, Le);
    if (r) {
      if (void 0 === t && (t = "default"), n = g(r, e, t), !J(n) || ie(n)) return n;
      throw je("Can't convert object to primitive value");
    }
    return void 0 === t && (t = "number"), function (e, t) {
      var n, r;
      if ("string" === t && H(n = e.toString) && !J(r = g(n, e))) return r;
      if (H(n = e.valueOf) && !J(r = g(n, e))) return r;
      if ("string" !== t && H(n = e.toString) && !J(r = g(n, e))) return r;
      throw fe("Can't convert object to primitive value");
    }(e, t);
  },
  We = function We(e) {
    var t = Re(e, "string");
    return ie(t) ? t : t + "";
  },
  Ze = p.document,
  Ee = J(Ze) && J(Ze.createElement),
  Ge = function Ge(e) {
    return Ee ? Ze.createElement(e) : {};
  },
  Ae = !v && !y(function () {
    return 7 != Object.defineProperty(Ge("div"), "a", {
      get: function get() {
        return 7;
      }
    }).a;
  }),
  Pe = Object.getOwnPropertyDescriptor,
  Xe = {
    f: v ? Pe : function (e, t) {
      if (e = K(e), t = We(t), Ae) try {
        return Pe(e, t);
      } catch (e) {}
      if (ge(e, t)) return I(!g(_.f, e, t), e[t]);
    }
  },
  Fe = v && y(function () {
    return 42 != Object.defineProperty(function () {}, "prototype", {
      value: 42,
      writable: !1
    }).prototype;
  }),
  Ke = String,
  Ne = TypeError,
  Ue = function Ue(e) {
    if (J(e)) return e;
    throw Ne(Ke(e) + " is not an object");
  },
  De = TypeError,
  He = Object.defineProperty,
  Ye = Object.getOwnPropertyDescriptor,
  Je = {
    f: v ? Fe ? function (e, t, n) {
      if (Ue(e), t = We(t), Ue(n), "function" == typeof e && "prototype" === t && "value" in n && "writable" in n && !n.writable) {
        var r = Ye(e, t);
        r && r.writable && (e[t] = n.value, n = {
          configurable: "configurable" in n ? n.configurable : r.configurable,
          enumerable: "enumerable" in n ? n.enumerable : r.enumerable,
          writable: !1
        });
      }
      return He(e, t, n);
    } : He : function (e, t, n) {
      if (Ue(e), t = We(t), Ue(n), Ae) try {
        return He(e, t, n);
      } catch (e) {}
      if ("get" in n || "set" in n) throw De("Accessors not supported");
      return "value" in n && (e[t] = n.value), e;
    }
  },
  Ve = v ? function (e, t, n) {
    return Je.f(e, t, I(1, n));
  } : function (e, t, n) {
    return e[t] = n, e;
  },
  ze = Function.prototype,
  Me = v && Object.getOwnPropertyDescriptor,
  Be = ge(ze, "name"),
  Qe = {
    EXISTS: Be,
    PROPER: Be && "something" === function () {}.name,
    CONFIGURABLE: Be && (!v || v && Me(ze, "name").configurable)
  },
  qe = L(Function.toString);
H(pe.inspectSource) || (pe.inspectSource = function (e) {
  return qe(e);
});
var $e,
  et,
  tt,
  nt = pe.inspectSource,
  rt = p.WeakMap,
  ot = H(rt) && /native code/.test(String(rt)),
  it = ye("keys"),
  ct = function ct(e) {
    return it[e] || (it[e] = _e(e));
  },
  at = {},
  st = p.TypeError,
  ut = p.WeakMap;
if (ot || pe.state) {
  var lt = pe.state || (pe.state = new ut()),
    ft = L(lt.get),
    dt = L(lt.has),
    ht = L(lt.set);
  $e = function $e(e, t) {
    if (dt(lt, e)) throw st("Object already initialized");
    return t.facade = e, ht(lt, e, t), t;
  }, et = function et(e) {
    return ft(lt, e) || {};
  }, tt = function tt(e) {
    return dt(lt, e);
  };
} else {
  var pt = ct("state");
  at[pt] = !0, $e = function $e(e, t) {
    if (ge(e, pt)) throw st("Object already initialized");
    return t.facade = e, Ve(e, pt, t), t;
  }, et = function et(e) {
    return ge(e, pt) ? e[pt] : {};
  }, tt = function tt(e) {
    return ge(e, pt);
  };
}
var yt = {
    set: $e,
    get: et,
    has: tt,
    enforce: function enforce(e) {
      return tt(e) ? et(e) : $e(e, {});
    },
    getterFor: function getterFor(e) {
      return function (t) {
        var n;
        if (!J(t) || (n = et(t)).type !== e) throw st("Incompatible receiver, " + e + " required");
        return n;
      };
    }
  },
  vt = l(function (e) {
    var t = Qe.CONFIGURABLE,
      n = yt.enforce,
      r = yt.get,
      o = Object.defineProperty,
      i = v && !y(function () {
        return 8 !== o(function () {}, "length", {
          value: 8
        }).length;
      }),
      c = String(String).split("String"),
      a = e.exports = function (e, r, a) {
        "Symbol(" === String(r).slice(0, 7) && (r = "[" + String(r).replace(/^Symbol\(([^)]*)\)/, "$1") + "]"), a && a.getter && (r = "get " + r), a && a.setter && (r = "set " + r), (!ge(e, "name") || t && e.name !== r) && (v ? o(e, "name", {
          value: r,
          configurable: !0
        }) : e.name = r), i && a && ge(a, "arity") && e.length !== a.arity && o(e, "length", {
          value: a.arity
        });
        try {
          a && ge(a, "constructor") && a.constructor ? v && o(e, "prototype", {
            writable: !1
          }) : e.prototype && (e.prototype = void 0);
        } catch (e) {}
        var s = n(e);
        return ge(s, "source") || (s.source = c.join("string" == typeof r ? r : "")), e;
      };
    Function.prototype.toString = a(function () {
      return H(this) && r(this).source || nt(this);
    }, "toString");
  }),
  mt = function mt(e, t, n, r) {
    r || (r = {});
    var o = r.enumerable,
      i = void 0 !== r.name ? r.name : t;
    if (H(n) && vt(n, i, r), r.global) o ? e[t] = n : he(t, n);else {
      try {
        r.unsafe ? e[t] && (o = !0) : delete e[t];
      } catch (e) {}
      o ? e[t] = n : Je.f(e, t, {
        value: n,
        enumerable: !1,
        configurable: !r.nonConfigurable,
        writable: !r.nonWritable
      });
    }
    return e;
  },
  bt = Math.ceil,
  gt = Math.floor,
  wt = Math.trunc || function (e) {
    var t = +e;
    return (t > 0 ? gt : bt)(t);
  },
  St = function St(e) {
    var t = +e;
    return t != t || 0 === t ? 0 : wt(t);
  },
  kt = Math.max,
  _t = Math.min,
  It = function It(e, t) {
    var n = St(e);
    return n < 0 ? kt(n + t, 0) : _t(n, t);
  },
  Ot = Math.min,
  xt = function xt(e) {
    return e > 0 ? Ot(St(e), 9007199254740991) : 0;
  },
  Tt = function Tt(e) {
    return xt(e.length);
  },
  Ct = function Ct(e) {
    return function (t, n, r) {
      var o,
        i = K(t),
        c = Tt(i),
        a = It(r, c);
      if (e && n != n) {
        for (; c > a;) if ((o = i[a++]) != o) return !0;
      } else for (; c > a; a++) if ((e || a in i) && i[a] === n) return e || a || 0;
      return !e && -1;
    };
  },
  jt = {
    includes: Ct(!0),
    indexOf: Ct(!1)
  },
  Lt = jt.indexOf,
  Rt = L([].push),
  Wt = function Wt(e, t) {
    var n,
      r = K(e),
      o = 0,
      i = [];
    for (n in r) !ge(at, n) && ge(r, n) && Rt(i, n);
    for (; t.length > o;) ge(r, n = t[o++]) && (~Lt(i, n) || Rt(i, n));
    return i;
  },
  Zt = ["constructor", "hasOwnProperty", "isPrototypeOf", "propertyIsEnumerable", "toLocaleString", "toString", "valueOf"],
  Et = Zt.concat("length", "prototype"),
  Gt = {
    f: Object.getOwnPropertyNames || function (e) {
      return Wt(e, Et);
    }
  },
  At = {
    f: Object.getOwnPropertySymbols
  },
  Pt = L([].concat),
  Xt = z("Reflect", "ownKeys") || function (e) {
    var t = Gt.f(Ue(e)),
      n = At.f;
    return n ? Pt(t, n(e)) : t;
  },
  Ft = function Ft(e, t, n) {
    for (var r = Xt(t), o = Je.f, i = Xe.f, c = 0; c < r.length; c++) {
      var a = r[c];
      ge(e, a) || n && ge(n, a) || o(e, a, i(t, a));
    }
  },
  Kt = /#|\.prototype\./,
  Nt = function Nt(e, t) {
    var n = Dt[Ut(e)];
    return n == Yt || n != Ht && (H(t) ? y(t) : !!t);
  },
  Ut = Nt.normalize = function (e) {
    return String(e).replace(Kt, ".").toLowerCase();
  },
  Dt = Nt.data = {},
  Ht = Nt.NATIVE = "N",
  Yt = Nt.POLYFILL = "P",
  Jt = Nt,
  Vt = Xe.f,
  zt = function zt(e, t) {
    var n,
      r,
      o,
      i,
      c,
      a = e.target,
      s = e.global,
      u = e.stat;
    if (n = s ? p : u ? p[a] || he(a, {}) : (p[a] || {}).prototype) for (r in t) {
      if (i = t[r], o = e.dontCallGetSet ? (c = Vt(n, r)) && c.value : n[r], !Jt(s ? r : a + (u ? "." : "#") + r, e.forced) && void 0 !== o) {
        if (typeof i == typeof o) continue;
        Ft(i, o);
      }
      (e.sham || o && o.sham) && Ve(i, "sham", !0), mt(n, r, i, e);
    }
  },
  Mt = {};
Mt[Ce("toStringTag")] = "z";
var Bt,
  Qt = "[object z]" === String(Mt),
  qt = Ce("toStringTag"),
  $t = Object,
  en = "Arguments" == Z(function () {
    return arguments;
  }()),
  tn = Qt ? Z : function (e) {
    var t, n, r;
    return void 0 === e ? "Undefined" : null === e ? "Null" : "string" == typeof (n = function (e, t) {
      try {
        return e[t];
      } catch (e) {}
    }(t = $t(e), qt)) ? n : en ? Z(t) : "Object" == (r = Z(t)) && H(t.callee) ? "Arguments" : r;
  },
  nn = String,
  rn = function rn(e) {
    if ("Symbol" === tn(e)) throw TypeError("Cannot convert a Symbol value to a string");
    return nn(e);
  },
  on = Ce("match"),
  cn = TypeError,
  an = function an(e) {
    if (function (e) {
      var t;
      return J(e) && (void 0 !== (t = e[on]) ? !!t : "RegExp" == Z(e));
    }(e)) throw cn("The method doesn't accept regular expressions");
    return e;
  },
  sn = Ce("match"),
  un = function un(e) {
    var t = /./;
    try {
      "/./"[e](t);
    } catch (n) {
      try {
        return t[sn] = !1, "/./"[e](t);
      } catch (e) {}
    }
    return !1;
  },
  ln = Xe.f,
  fn = L("".startsWith),
  dn = L("".slice),
  hn = Math.min,
  pn = un("startsWith"),
  yn = !(pn || (Bt = ln(String.prototype, "startsWith"), !Bt || Bt.writable));
zt({
  target: "String",
  proto: !0,
  forced: !yn && !pn
}, {
  startsWith: function startsWith(e) {
    var t = rn(F(this));
    an(e);
    var n = xt(hn(arguments.length > 1 ? arguments[1] : void 0, t.length)),
      r = rn(e);
    return fn ? fn(t, r, n) : dn(t, n, n + r.length) === r;
  }
});
var vn = function vn(e, t) {
  return L(p[e].prototype[t]);
};
vn("String", "startsWith");
var mn = Array.isArray || function (e) {
    return "Array" == Z(e);
  },
  bn = TypeError,
  gn = function gn(e) {
    if (e > 9007199254740991) throw bn("Maximum allowed index exceeded");
    return e;
  },
  wn = function wn(e, t, n) {
    var r = We(t);
    r in e ? Je.f(e, r, I(0, n)) : e[r] = n;
  },
  Sn = function Sn() {},
  kn = [],
  _n = z("Reflect", "construct"),
  In = /^\s*(?:class|function)\b/,
  On = L(In.exec),
  xn = !In.exec(Sn),
  Tn = function Tn(e) {
    if (!H(e)) return !1;
    try {
      return _n(Sn, kn, e), !0;
    } catch (e) {
      return !1;
    }
  },
  Cn = function Cn(e) {
    if (!H(e)) return !1;
    switch (tn(e)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return xn || !!On(In, nt(e));
    } catch (e) {
      return !0;
    }
  };
Cn.sham = !0;
var jn,
  Ln = !_n || y(function () {
    var e;
    return Tn(Tn.call) || !Tn(Object) || !Tn(function () {
      e = !0;
    }) || e;
  }) ? Cn : Tn,
  Rn = Ce("species"),
  Wn = Array,
  Zn = function Zn(e, t) {
    return new (function (e) {
      var t;
      return mn(e) && (t = e.constructor, (Ln(t) && (t === Wn || mn(t.prototype)) || J(t) && null === (t = t[Rn])) && (t = void 0)), void 0 === t ? Wn : t;
    }(e))(0 === t ? 0 : t);
  },
  En = Ce("species"),
  Gn = Ce("isConcatSpreadable"),
  An = te >= 51 || !y(function () {
    var e = [];
    return e[Gn] = !1, e.concat()[0] !== e;
  }),
  Pn = (jn = "concat", te >= 51 || !y(function () {
    var e = [];
    return (e.constructor = {})[En] = function () {
      return {
        foo: 1
      };
    }, 1 !== e[jn](Boolean).foo;
  })),
  Xn = function Xn(e) {
    if (!J(e)) return !1;
    var t = e[Gn];
    return void 0 !== t ? !!t : mn(e);
  };
zt({
  target: "Array",
  proto: !0,
  arity: 1,
  forced: !An || !Pn
}, {
  concat: function concat(e) {
    var t,
      n,
      r,
      o,
      i,
      c = me(this),
      a = Zn(c, 0),
      s = 0;
    for (t = -1, r = arguments.length; t < r; t++) if (Xn(i = -1 === t ? c : arguments[t])) for (o = Tt(i), gn(s + o), n = 0; n < o; n++, s++) n in i && wn(a, s, i[n]);else gn(s + 1), wn(a, s++, i);
    return a.length = s, a;
  }
});
var Fn = Qt ? {}.toString : function () {
  return "[object " + tn(this) + "]";
};
Qt || mt(Object.prototype, "toString", Fn, {
  unsafe: !0
});
var Kn,
  Nn = Object.keys || function (e) {
    return Wt(e, Zt);
  },
  Un = v && !Fe ? Object.defineProperties : function (e, t) {
    Ue(e);
    for (var n, r = K(t), o = Nn(t), i = o.length, c = 0; i > c;) Je.f(e, n = o[c++], r[n]);
    return e;
  },
  Dn = {
    f: Un
  },
  Hn = z("document", "documentElement"),
  Yn = ct("IE_PROTO"),
  Jn = function Jn() {},
  Vn = function Vn(e) {
    return "<script>" + e + "<\/script>";
  },
  zn = function zn(e) {
    e.write(Vn("")), e.close();
    var t = e.parentWindow.Object;
    return e = null, t;
  },
  _Mn = function Mn() {
    try {
      Kn = new ActiveXObject("htmlfile");
    } catch (e) {}
    var e, t;
    _Mn = "undefined" != typeof document ? document.domain && Kn ? zn(Kn) : ((t = Ge("iframe")).style.display = "none", Hn.appendChild(t), t.src = String("javascript:"), (e = t.contentWindow.document).open(), e.write(Vn("document.F=Object")), e.close(), e.F) : zn(Kn);
    for (var n = Zt.length; n--;) delete _Mn.prototype[Zt[n]];
    return _Mn();
  };
at[Yn] = !0;
var Bn = Object.create || function (e, t) {
    var n;
    return null !== e ? (Jn.prototype = Ue(e), n = new Jn(), Jn.prototype = null, n[Yn] = e) : n = _Mn(), void 0 === t ? n : Dn.f(n, t);
  },
  Qn = Array,
  qn = Math.max,
  $n = Gt.f,
  er = "object" == typeof window && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
  tr = function tr(e) {
    try {
      return $n(e);
    } catch (e) {
      return function (e, t, n) {
        for (var r = Tt(e), o = It(t, r), i = It(void 0 === n ? r : n, r), c = Qn(qn(i - o, 0)), a = 0; o < i; o++, a++) wn(c, a, e[o]);
        return c.length = a, c;
      }(er);
    }
  },
  nr = {
    f: function f(e) {
      return er && "Window" == Z(e) ? tr(e) : $n(K(e));
    }
  },
  rr = {
    f: Ce
  },
  or = p,
  ir = Je.f,
  cr = function cr(e) {
    var t = or.Symbol || (or.Symbol = {});
    ge(t, e) || ir(t, e, {
      value: rr.f(e)
    });
  },
  ar = function ar() {
    var e = z("Symbol"),
      t = e && e.prototype,
      n = t && t.valueOf,
      r = Ce("toPrimitive");
    t && !t[r] && mt(t, r, function (e) {
      return g(n, this);
    }, {
      arity: 1
    });
  },
  sr = Je.f,
  ur = Ce("toStringTag"),
  lr = function lr(e, t, n) {
    e && !n && (e = e.prototype), e && !ge(e, ur) && sr(e, ur, {
      configurable: !0,
      value: t
    });
  },
  fr = L(L.bind),
  dr = function dr(e, t) {
    return ue(e), void 0 === t ? e : m ? fr(e, t) : function () {
      return e.apply(t, arguments);
    };
  },
  hr = L([].push),
  pr = function pr(e) {
    var t = 1 == e,
      n = 2 == e,
      r = 3 == e,
      o = 4 == e,
      i = 6 == e,
      c = 7 == e,
      a = 5 == e || i;
    return function (s, u, l, f) {
      for (var d, h, p = me(s), y = A(p), v = dr(u, l), m = Tt(y), b = 0, g = f || Zn, w = t ? g(s, m) : n || c ? g(s, 0) : void 0; m > b; b++) if ((a || b in y) && (h = v(d = y[b], b, p), e)) if (t) w[b] = h;else if (h) switch (e) {
        case 3:
          return !0;
        case 5:
          return d;
        case 6:
          return b;
        case 2:
          hr(w, d);
      } else switch (e) {
        case 4:
          return !1;
        case 7:
          hr(w, d);
      }
      return i ? -1 : r || o ? o : w;
    };
  },
  yr = {
    forEach: pr(0),
    map: pr(1),
    filter: pr(2),
    some: pr(3),
    every: pr(4),
    find: pr(5),
    findIndex: pr(6),
    filterReject: pr(7)
  }.forEach,
  vr = ct("hidden"),
  mr = yt.set,
  br = yt.getterFor("Symbol"),
  gr = Object.prototype,
  wr = p.Symbol,
  Sr = wr && wr.prototype,
  kr = p.TypeError,
  _r = p.QObject,
  Ir = Xe.f,
  Or = Je.f,
  xr = nr.f,
  Tr = _.f,
  Cr = L([].push),
  jr = ye("symbols"),
  Lr = ye("op-symbols"),
  Rr = ye("wks"),
  Wr = !_r || !_r.prototype || !_r.prototype.findChild,
  Zr = v && y(function () {
    return 7 != Bn(Or({}, "a", {
      get: function get() {
        return Or(this, "a", {
          value: 7
        }).a;
      }
    })).a;
  }) ? function (e, t, n) {
    var r = Ir(gr, t);
    r && delete gr[t], Or(e, t, n), r && e !== gr && Or(gr, t, r);
  } : Or,
  Er = function Er(e, t) {
    var n = jr[e] = Bn(Sr);
    return mr(n, {
      type: "Symbol",
      tag: e,
      description: t
    }), v || (n.description = t), n;
  },
  _Gr = function Gr(e, t, n) {
    e === gr && _Gr(Lr, t, n), Ue(e);
    var r = We(t);
    return Ue(n), ge(jr, r) ? (n.enumerable ? (ge(e, vr) && e[vr][r] && (e[vr][r] = !1), n = Bn(n, {
      enumerable: I(0, !1)
    })) : (ge(e, vr) || Or(e, vr, I(1, {})), e[vr][r] = !0), Zr(e, r, n)) : Or(e, r, n);
  },
  Ar = function Ar(e, t) {
    Ue(e);
    var n = K(t),
      r = Nn(n).concat(Kr(n));
    return yr(r, function (t) {
      v && !g(Pr, n, t) || _Gr(e, t, n[t]);
    }), e;
  },
  Pr = function Pr(e) {
    var t = We(e),
      n = g(Tr, this, t);
    return !(this === gr && ge(jr, t) && !ge(Lr, t)) && (!(n || !ge(this, t) || !ge(jr, t) || ge(this, vr) && this[vr][t]) || n);
  },
  Xr = function Xr(e, t) {
    var n = K(e),
      r = We(t);
    if (n !== gr || !ge(jr, r) || ge(Lr, r)) {
      var o = Ir(n, r);
      return !o || !ge(jr, r) || ge(n, vr) && n[vr][r] || (o.enumerable = !0), o;
    }
  },
  Fr = function Fr(e) {
    var t = xr(K(e)),
      n = [];
    return yr(t, function (e) {
      ge(jr, e) || ge(at, e) || Cr(n, e);
    }), n;
  },
  Kr = function Kr(e) {
    var t = e === gr,
      n = xr(t ? Lr : K(e)),
      r = [];
    return yr(n, function (e) {
      !ge(jr, e) || t && !ge(gr, e) || Cr(r, jr[e]);
    }), r;
  };
ne || (Sr = (wr = function wr() {
  if (M(Sr, this)) throw kr("Symbol is not a constructor");
  var e = arguments.length && void 0 !== arguments[0] ? rn(arguments[0]) : void 0,
    t = _e(e),
    _n3 = function n(e) {
      this === gr && g(_n3, Lr, e), ge(this, vr) && ge(this[vr], t) && (this[vr][t] = !1), Zr(this, t, I(1, e));
    };
  return v && Wr && Zr(gr, t, {
    configurable: !0,
    set: _n3
  }), Er(t, e);
}).prototype, mt(Sr, "toString", function () {
  return br(this).tag;
}), mt(wr, "withoutSetter", function (e) {
  return Er(_e(e), e);
}), _.f = Pr, Je.f = _Gr, Dn.f = Ar, Xe.f = Xr, Gt.f = nr.f = Fr, At.f = Kr, rr.f = function (e) {
  return Er(Ce(e), e);
}, v && (Or(Sr, "description", {
  configurable: !0,
  get: function get() {
    return br(this).description;
  }
}), mt(gr, "propertyIsEnumerable", Pr, {
  unsafe: !0
}))), zt({
  global: !0,
  constructor: !0,
  wrap: !0,
  forced: !ne,
  sham: !ne
}, {
  Symbol: wr
}), yr(Nn(Rr), function (e) {
  cr(e);
}), zt({
  target: "Symbol",
  stat: !0,
  forced: !ne
}, {
  useSetter: function useSetter() {
    Wr = !0;
  },
  useSimple: function useSimple() {
    Wr = !1;
  }
}), zt({
  target: "Object",
  stat: !0,
  forced: !ne,
  sham: !v
}, {
  create: function create(e, t) {
    return void 0 === t ? Bn(e) : Ar(Bn(e), t);
  },
  defineProperty: _Gr,
  defineProperties: Ar,
  getOwnPropertyDescriptor: Xr
}), zt({
  target: "Object",
  stat: !0,
  forced: !ne
}, {
  getOwnPropertyNames: Fr
}), ar(), lr(wr, "Symbol"), at[vr] = !0;
var Nr = ne && !!Symbol.for && !!Symbol.keyFor,
  Ur = ye("string-to-symbol-registry"),
  Dr = ye("symbol-to-string-registry");
zt({
  target: "Symbol",
  stat: !0,
  forced: !Nr
}, {
  for: function _for(e) {
    var t = rn(e);
    if (ge(Ur, t)) return Ur[t];
    var n = z("Symbol")(t);
    return Ur[t] = n, Dr[n] = t, n;
  }
});
var Hr = ye("symbol-to-string-registry");
zt({
  target: "Symbol",
  stat: !0,
  forced: !Nr
}, {
  keyFor: function keyFor(e) {
    if (!ie(e)) throw TypeError(ae(e) + " is not a symbol");
    if (ge(Hr, e)) return Hr[e];
  }
});
var Yr = Function.prototype,
  Jr = Yr.apply,
  Vr = Yr.call,
  zr = "object" == typeof Reflect && Reflect.apply || (m ? Vr.bind(Jr) : function () {
    return Vr.apply(Jr, arguments);
  }),
  Mr = L([].slice),
  Br = z("JSON", "stringify"),
  Qr = L(/./.exec),
  qr = L("".charAt),
  $r = L("".charCodeAt),
  eo = L("".replace),
  to = L(1..toString),
  no = /[\uD800-\uDFFF]/g,
  ro = /^[\uD800-\uDBFF]$/,
  oo = /^[\uDC00-\uDFFF]$/,
  io = !ne || y(function () {
    var e = z("Symbol")();
    return "[null]" != Br([e]) || "{}" != Br({
      a: e
    }) || "{}" != Br(Object(e));
  }),
  co = y(function () {
    return "\"\\udf06\\ud834\"" !== Br("\uDF06\uD834") || "\"\\udead\"" !== Br("\uDEAD");
  }),
  ao = function ao(e, t) {
    var n = Mr(arguments),
      r = t;
    if ((J(t) || void 0 !== e) && !ie(e)) return mn(t) || (t = function t(e, _t2) {
      if (H(r) && (_t2 = g(r, this, e, _t2)), !ie(_t2)) return _t2;
    }), n[1] = t, zr(Br, null, n);
  },
  so = function so(e, t, n) {
    var r = qr(n, t - 1),
      o = qr(n, t + 1);
    return Qr(ro, e) && !Qr(oo, o) || Qr(oo, e) && !Qr(ro, r) ? "\\u" + to($r(e, 0), 16) : e;
  };
Br && zt({
  target: "JSON",
  stat: !0,
  arity: 3,
  forced: io || co
}, {
  stringify: function stringify(e, t, n) {
    var r = Mr(arguments),
      o = zr(io ? ao : Br, null, r);
    return co && "string" == typeof o ? eo(o, no, so) : o;
  }
});
var uo = !ne || y(function () {
  At.f(1);
});
zt({
  target: "Object",
  stat: !0,
  forced: uo
}, {
  getOwnPropertySymbols: function getOwnPropertySymbols(e) {
    var t = At.f;
    return t ? t(me(e)) : [];
  }
}), cr("asyncIterator");
var lo = Je.f,
  fo = p.Symbol,
  ho = fo && fo.prototype;
if (v && H(fo) && (!("description" in ho) || void 0 !== fo().description)) {
  var po = {},
    yo = function yo() {
      var e = arguments.length < 1 || void 0 === arguments[0] ? void 0 : rn(arguments[0]),
        t = M(ho, this) ? new fo(e) : void 0 === e ? fo() : fo(e);
      return "" === e && (po[t] = !0), t;
    };
  Ft(yo, fo), yo.prototype = ho, ho.constructor = yo;
  var vo = "Symbol(test)" == String(fo("test")),
    mo = L(ho.valueOf),
    bo = L(ho.toString),
    go = /^Symbol\((.*)\)[^)]+$/,
    wo = L("".replace),
    So = L("".slice);
  lo(ho, "description", {
    configurable: !0,
    get: function get() {
      var e = mo(this);
      if (ge(po, e)) return "";
      var t = bo(e),
        n = vo ? So(t, 7, -1) : wo(t, go, "$1");
      return "" === n ? void 0 : n;
    }
  }), zt({
    global: !0,
    constructor: !0,
    forced: !0
  }, {
    Symbol: yo
  });
}
cr("hasInstance"), cr("isConcatSpreadable"), cr("iterator"), cr("match"), cr("matchAll"), cr("replace"), cr("search"), cr("species"), cr("split"), cr("toPrimitive"), ar(), cr("toStringTag"), lr(z("Symbol"), "Symbol"), cr("unscopables"), lr(p.JSON, "JSON", !0), lr(Math, "Math", !0), zt({
  global: !0
}, {
  Reflect: {}
}), lr(p.Reflect, "Reflect", !0), or.Symbol;
var ko,
  _o,
  Io,
  Oo = L("".charAt),
  xo = L("".charCodeAt),
  To = L("".slice),
  Co = function Co(e) {
    return function (t, n) {
      var r,
        o,
        i = rn(F(t)),
        c = St(n),
        a = i.length;
      return c < 0 || c >= a ? e ? "" : void 0 : (r = xo(i, c)) < 55296 || r > 56319 || c + 1 === a || (o = xo(i, c + 1)) < 56320 || o > 57343 ? e ? Oo(i, c) : r : e ? To(i, c, c + 2) : o - 56320 + (r - 55296 << 10) + 65536;
    };
  },
  jo = {
    codeAt: Co(!1),
    charAt: Co(!0)
  },
  Lo = !y(function () {
    function e() {}
    return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype;
  }),
  Ro = ct("IE_PROTO"),
  Wo = Object,
  Zo = Wo.prototype,
  Eo = Lo ? Wo.getPrototypeOf : function (e) {
    var t = me(e);
    if (ge(t, Ro)) return t[Ro];
    var n = t.constructor;
    return H(n) && t instanceof n ? n.prototype : t instanceof Wo ? Zo : null;
  },
  Go = Ce("iterator"),
  Ao = !1;
[].keys && ("next" in (Io = [].keys()) ? (_o = Eo(Eo(Io))) !== Object.prototype && (ko = _o) : Ao = !0);
var Po = !J(ko) || y(function () {
  var e = {};
  return ko[Go].call(e) !== e;
});
Po && (ko = {}), H(ko[Go]) || mt(ko, Go, function () {
  return this;
});
var Xo = {
    IteratorPrototype: ko,
    BUGGY_SAFARI_ITERATORS: Ao
  },
  Fo = {},
  Ko = Xo.IteratorPrototype,
  No = function No() {
    return this;
  },
  Uo = String,
  Do = TypeError,
  Ho = Object.setPrototypeOf || ("__proto__" in {} ? function () {
    var e,
      t = !1,
      n = {};
    try {
      (e = L(Object.getOwnPropertyDescriptor(Object.prototype, "__proto__").set))(n, []), t = n instanceof Array;
    } catch (e) {}
    return function (n, r) {
      return Ue(n), function (e) {
        if ("object" == typeof e || H(e)) return e;
        throw Do("Can't set " + Uo(e) + " as a prototype");
      }(r), t ? e(n, r) : n.__proto__ = r, n;
    };
  }() : void 0),
  Yo = Qe.PROPER,
  Jo = Qe.CONFIGURABLE,
  Vo = Xo.IteratorPrototype,
  zo = Xo.BUGGY_SAFARI_ITERATORS,
  Mo = Ce("iterator"),
  Bo = function Bo() {
    return this;
  },
  Qo = function Qo(e, t, n, r, o, i, c) {
    !function (e, t, n, r) {
      var o = t + " Iterator";
      e.prototype = Bn(Ko, {
        next: I(+!r, n)
      }), lr(e, o, !1), Fo[o] = No;
    }(n, t, r);
    var a,
      s,
      u,
      l = function l(e) {
        if (e === o && y) return y;
        if (!zo && e in h) return h[e];
        switch (e) {
          case "keys":
          case "values":
          case "entries":
            return function () {
              return new n(this, e);
            };
        }
        return function () {
          return new n(this);
        };
      },
      f = t + " Iterator",
      d = !1,
      h = e.prototype,
      p = h[Mo] || h["@@iterator"] || o && h[o],
      y = !zo && p || l(o),
      v = "Array" == t && h.entries || p;
    if (v && (a = Eo(v.call(new e()))) !== Object.prototype && a.next && (Eo(a) !== Vo && (Ho ? Ho(a, Vo) : H(a[Mo]) || mt(a, Mo, Bo)), lr(a, f, !0)), Yo && "values" == o && p && "values" !== p.name && (Jo ? Ve(h, "name", "values") : (d = !0, y = function y() {
      return g(p, this);
    })), o) if (s = {
      values: l("values"),
      keys: i ? y : l("keys"),
      entries: l("entries")
    }, c) for (u in s) (zo || d || !(u in h)) && mt(h, u, s[u]);else zt({
      target: t,
      proto: !0,
      forced: zo || d
    }, s);
    return h[Mo] !== y && mt(h, Mo, y, {
      name: o
    }), Fo[t] = y, s;
  },
  qo = function qo(e, t) {
    return {
      value: e,
      done: t
    };
  },
  $o = jo.charAt,
  ei = yt.set,
  ti = yt.getterFor("String Iterator");
Qo(String, "String", function (e) {
  ei(this, {
    type: "String Iterator",
    string: rn(e),
    index: 0
  });
}, function () {
  var e,
    t = ti(this),
    n = t.string,
    r = t.index;
  return r >= n.length ? qo(void 0, !0) : (e = $o(n, r), t.index += e.length, qo(e, !1));
});
var ni = function ni(e, t, n) {
    var r, o;
    Ue(e);
    try {
      if (!(r = le(e, "return"))) {
        if ("throw" === t) throw n;
        return n;
      }
      r = g(r, e);
    } catch (e) {
      o = !0, r = e;
    }
    if ("throw" === t) throw n;
    if (o) throw r;
    return Ue(r), n;
  },
  ri = function ri(e, t, n, r) {
    try {
      return r ? t(Ue(n)[0], n[1]) : t(n);
    } catch (t) {
      ni(e, "throw", t);
    }
  },
  oi = Ce("iterator"),
  ii = Array.prototype,
  ci = function ci(e) {
    return void 0 !== e && (Fo.Array === e || ii[oi] === e);
  },
  ai = Ce("iterator"),
  si = function si(e) {
    if (!P(e)) return le(e, ai) || le(e, "@@iterator") || Fo[tn(e)];
  },
  ui = TypeError,
  li = function li(e, t) {
    var n = arguments.length < 2 ? si(e) : t;
    if (ue(n)) return Ue(g(n, e));
    throw ui(ae(e) + " is not iterable");
  },
  fi = Array,
  di = Ce("iterator"),
  hi = !1;
try {
  var pi = 0,
    yi = {
      next: function next() {
        return {
          done: !!pi++
        };
      },
      return: function _return() {
        hi = !0;
      }
    };
  yi[di] = function () {
    return this;
  }, Array.from(yi, function () {
    throw 2;
  });
} catch (e) {}
var vi = function vi(e, t) {
    if (!t && !hi) return !1;
    var n = !1;
    try {
      var r = {};
      r[di] = function () {
        return {
          next: function next() {
            return {
              done: n = !0
            };
          }
        };
      }, e(r);
    } catch (e) {}
    return n;
  },
  mi = !vi(function (e) {
    Array.from(e);
  });
zt({
  target: "Array",
  stat: !0,
  forced: mi
}, {
  from: function from(e) {
    var t = me(e),
      n = Ln(this),
      r = arguments.length,
      o = r > 1 ? arguments[1] : void 0,
      i = void 0 !== o;
    i && (o = dr(o, r > 2 ? arguments[2] : void 0));
    var c,
      a,
      s,
      u,
      l,
      f,
      d = si(t),
      h = 0;
    if (!d || this === fi && ci(d)) for (c = Tt(t), a = n ? new this(c) : fi(c); c > h; h++) f = i ? o(t[h], h) : t[h], wn(a, h, f);else for (l = (u = li(t, d)).next, a = n ? new this() : []; !(s = g(l, u)).done; h++) f = i ? ri(u, o, [s.value, h], !0) : s.value, wn(a, h, f);
    return a.length = h, a;
  }
}), or.Array.from;
var bi,
  gi,
  wi,
  Si = "undefined" != typeof ArrayBuffer && "undefined" != typeof DataView,
  ki = Je.f,
  _i = yt.enforce,
  Ii = yt.get,
  Oi = p.Int8Array,
  xi = Oi && Oi.prototype,
  Ti = p.Uint8ClampedArray,
  Ci = Ti && Ti.prototype,
  ji = Oi && Eo(Oi),
  Li = xi && Eo(xi),
  Ri = Object.prototype,
  Wi = p.TypeError,
  Zi = Ce("toStringTag"),
  Ei = _e("TYPED_ARRAY_TAG"),
  Gi = Si && !!Ho && "Opera" !== tn(p.opera),
  Ai = !1,
  Pi = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
  },
  Xi = {
    BigInt64Array: 8,
    BigUint64Array: 8
  },
  _Fi = function Fi(e) {
    var t = Eo(e);
    if (J(t)) {
      var n = Ii(t);
      return n && ge(n, "TypedArrayConstructor") ? n.TypedArrayConstructor : _Fi(t);
    }
  },
  Ki = function Ki(e) {
    if (!J(e)) return !1;
    var t = tn(e);
    return ge(Pi, t) || ge(Xi, t);
  };
for (bi in Pi) (wi = (gi = p[bi]) && gi.prototype) ? _i(wi).TypedArrayConstructor = gi : Gi = !1;
for (bi in Xi) (wi = (gi = p[bi]) && gi.prototype) && (_i(wi).TypedArrayConstructor = gi);
if ((!Gi || !H(ji) || ji === Function.prototype) && (ji = function ji() {
  throw Wi("Incorrect invocation");
}, Gi)) for (bi in Pi) p[bi] && Ho(p[bi], ji);
if ((!Gi || !Li || Li === Ri) && (Li = ji.prototype, Gi)) for (bi in Pi) p[bi] && Ho(p[bi].prototype, Li);
if (Gi && Eo(Ci) !== Li && Ho(Ci, Li), v && !ge(Li, Zi)) for (bi in Ai = !0, ki(Li, Zi, {
  get: function get() {
    return J(this) ? this[Ei] : void 0;
  }
}), Pi) p[bi] && Ve(p[bi], Ei, bi);
var Ni = {
    NATIVE_ARRAY_BUFFER_VIEWS: Gi,
    TYPED_ARRAY_TAG: Ai && Ei,
    aTypedArray: function aTypedArray(e) {
      if (Ki(e)) return e;
      throw Wi("Target is not a typed array");
    },
    aTypedArrayConstructor: function aTypedArrayConstructor(e) {
      if (H(e) && (!Ho || M(ji, e))) return e;
      throw Wi(ae(e) + " is not a typed array constructor");
    },
    exportTypedArrayMethod: function exportTypedArrayMethod(e, t, n, r) {
      if (v) {
        if (n) for (var o in Pi) {
          var i = p[o];
          if (i && ge(i.prototype, e)) try {
            delete i.prototype[e];
          } catch (n) {
            try {
              i.prototype[e] = t;
            } catch (e) {}
          }
        }
        Li[e] && !n || mt(Li, e, n ? t : Gi && xi[e] || t, r);
      }
    },
    exportTypedArrayStaticMethod: function exportTypedArrayStaticMethod(e, t, n) {
      var r, o;
      if (v) {
        if (Ho) {
          if (n) for (r in Pi) if ((o = p[r]) && ge(o, e)) try {
            delete o[e];
          } catch (e) {}
          if (ji[e] && !n) return;
          try {
            return mt(ji, e, n ? t : Gi && ji[e] || t);
          } catch (e) {}
        }
        for (r in Pi) !(o = p[r]) || o[e] && !n || mt(o, e, t);
      }
    },
    getTypedArrayConstructor: _Fi,
    isView: function isView(e) {
      if (!J(e)) return !1;
      var t = tn(e);
      return "DataView" === t || ge(Pi, t) || ge(Xi, t);
    },
    isTypedArray: Ki,
    TypedArray: ji,
    TypedArrayPrototype: Li
  },
  Ui = TypeError,
  Di = Ce("species"),
  Hi = function Hi(e, t) {
    var n,
      r = Ue(e).constructor;
    return void 0 === r || P(n = Ue(r)[Di]) ? t : function (e) {
      if (Ln(e)) return e;
      throw Ui(ae(e) + " is not a constructor");
    }(n);
  },
  Yi = Ni.aTypedArrayConstructor,
  Ji = Ni.getTypedArrayConstructor,
  Vi = Ni.aTypedArray;
(0, Ni.exportTypedArrayMethod)("slice", function (e, t) {
  for (var n, r = Mr(Vi(this), e, t), o = Yi(Hi(n = this, Ji(n))), i = 0, c = r.length, a = new o(c); c > i;) a[i] = r[i++];
  return a;
}, y(function () {
  new Int8Array(1).slice();
}));
var zi = Je.f,
  Mi = Ce("unscopables"),
  Bi = Array.prototype;
null == Bi[Mi] && zi(Bi, Mi, {
  configurable: !0,
  value: Bn(null)
});
var Qi = function Qi(e) {
    Bi[Mi][e] = !0;
  },
  qi = jt.includes,
  $i = y(function () {
    return !Array(1).includes();
  });
zt({
  target: "Array",
  proto: !0,
  forced: $i
}, {
  includes: function includes(e) {
    return qi(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
}), Qi("includes"), vn("Array", "includes");
var ec = L("".indexOf);
zt({
  target: "String",
  proto: !0,
  forced: !un("includes")
}, {
  includes: function includes(e) {
    return !!~ec(rn(F(this)), rn(an(e)), arguments.length > 1 ? arguments[1] : void 0);
  }
}), vn("String", "includes");
var tc = Je.f,
  nc = yt.set,
  rc = yt.getterFor("Array Iterator");
Qo(Array, "Array", function (e, t) {
  nc(this, {
    type: "Array Iterator",
    target: K(e),
    index: 0,
    kind: t
  });
}, function () {
  var e = rc(this),
    t = e.target,
    n = e.kind,
    r = e.index++;
  return !t || r >= t.length ? (e.target = void 0, qo(void 0, !0)) : qo("keys" == n ? r : "values" == n ? t[r] : [r, t[r]], !1);
}, "values");
var oc = Fo.Arguments = Fo.Array;
if (Qi("keys"), Qi("values"), Qi("entries"), v && "values" !== oc.name) try {
  tc(oc, "name", {
    value: "values"
  });
} catch (e) {}
var ic = y(function () {
    if ("function" == typeof ArrayBuffer) {
      var e = new ArrayBuffer(8);
      Object.isExtensible(e) && Object.defineProperty(e, "a", {
        value: 8
      });
    }
  }),
  cc = Object.isExtensible,
  ac = y(function () {
    cc(1);
  }) || ic ? function (e) {
    return !!J(e) && (!ic || "ArrayBuffer" != Z(e)) && (!cc || cc(e));
  } : cc,
  sc = !y(function () {
    return Object.isExtensible(Object.preventExtensions({}));
  }),
  uc = l(function (e) {
    var t = Je.f,
      n = !1,
      r = _e("meta"),
      o = 0,
      i = function i(e) {
        t(e, r, {
          value: {
            objectID: "O" + o++,
            weakData: {}
          }
        });
      },
      c = e.exports = {
        enable: function enable() {
          c.enable = function () {}, n = !0;
          var e = Gt.f,
            t = L([].splice),
            o = {};
          o[r] = 1, e(o).length && (Gt.f = function (n) {
            for (var o = e(n), i = 0, c = o.length; i < c; i++) if (o[i] === r) {
              t(o, i, 1);
              break;
            }
            return o;
          }, zt({
            target: "Object",
            stat: !0,
            forced: !0
          }, {
            getOwnPropertyNames: nr.f
          }));
        },
        fastKey: function fastKey(e, t) {
          if (!J(e)) return "symbol" == typeof e ? e : ("string" == typeof e ? "S" : "P") + e;
          if (!ge(e, r)) {
            if (!ac(e)) return "F";
            if (!t) return "E";
            i(e);
          }
          return e[r].objectID;
        },
        getWeakData: function getWeakData(e, t) {
          if (!ge(e, r)) {
            if (!ac(e)) return !0;
            if (!t) return !1;
            i(e);
          }
          return e[r].weakData;
        },
        onFreeze: function onFreeze(e) {
          return sc && n && ac(e) && !ge(e, r) && i(e), e;
        }
      };
    at[r] = !0;
  });
uc.enable, uc.fastKey, uc.getWeakData, uc.onFreeze;
var lc = TypeError,
  fc = function fc(e, t) {
    this.stopped = e, this.result = t;
  },
  dc = fc.prototype,
  hc = function hc(e, t, n) {
    var r,
      o,
      i,
      c,
      a,
      s,
      u,
      l = n && n.that,
      f = !(!n || !n.AS_ENTRIES),
      d = !(!n || !n.IS_RECORD),
      h = !(!n || !n.IS_ITERATOR),
      p = !(!n || !n.INTERRUPTED),
      y = dr(t, l),
      v = function v(e) {
        return r && ni(r, "normal", e), new fc(!0, e);
      },
      m = function m(e) {
        return f ? (Ue(e), p ? y(e[0], e[1], v) : y(e[0], e[1])) : p ? y(e, v) : y(e);
      };
    if (d) r = e.iterator;else if (h) r = e;else {
      if (!(o = si(e))) throw lc(ae(e) + " is not iterable");
      if (ci(o)) {
        for (i = 0, c = Tt(e); c > i; i++) if ((a = m(e[i])) && M(dc, a)) return a;
        return new fc(!1);
      }
      r = li(e, o);
    }
    for (s = d ? e.next : r.next; !(u = g(s, r)).done;) {
      try {
        a = m(u.value);
      } catch (e) {
        ni(r, "throw", e);
      }
      if ("object" == typeof a && a && M(dc, a)) return a;
    }
    return new fc(!1);
  },
  pc = TypeError,
  yc = function yc(e, t) {
    if (M(t, e)) return e;
    throw pc("Incorrect invocation");
  },
  vc = function vc(e, t, n) {
    for (var r in t) mt(e, r, t[r], n);
    return e;
  },
  mc = Ce("species"),
  bc = Je.f,
  gc = uc.fastKey,
  wc = yt.set,
  Sc = yt.getterFor,
  kc = {
    getConstructor: function getConstructor(e, t, n, r) {
      var o = e(function (e, o) {
          yc(e, i), wc(e, {
            type: t,
            index: Bn(null),
            first: void 0,
            last: void 0,
            size: 0
          }), v || (e.size = 0), P(o) || hc(o, e[r], {
            that: e,
            AS_ENTRIES: n
          });
        }),
        i = o.prototype,
        c = Sc(t),
        a = function a(e, t, n) {
          var r,
            o,
            i = c(e),
            a = s(e, t);
          return a ? a.value = n : (i.last = a = {
            index: o = gc(t, !0),
            key: t,
            value: n,
            previous: r = i.last,
            next: void 0,
            removed: !1
          }, i.first || (i.first = a), r && (r.next = a), v ? i.size++ : e.size++, "F" !== o && (i.index[o] = a)), e;
        },
        s = function s(e, t) {
          var n,
            r = c(e),
            o = gc(t);
          if ("F" !== o) return r.index[o];
          for (n = r.first; n; n = n.next) if (n.key == t) return n;
        };
      return vc(i, {
        clear: function clear() {
          for (var e = c(this), t = e.index, n = e.first; n;) n.removed = !0, n.previous && (n.previous = n.previous.next = void 0), delete t[n.index], n = n.next;
          e.first = e.last = void 0, v ? e.size = 0 : this.size = 0;
        },
        delete: function _delete(e) {
          var t = this,
            n = c(t),
            r = s(t, e);
          if (r) {
            var o = r.next,
              i = r.previous;
            delete n.index[r.index], r.removed = !0, i && (i.next = o), o && (o.previous = i), n.first == r && (n.first = o), n.last == r && (n.last = i), v ? n.size-- : t.size--;
          }
          return !!r;
        },
        forEach: function forEach(e) {
          for (var t, n = c(this), r = dr(e, arguments.length > 1 ? arguments[1] : void 0); t = t ? t.next : n.first;) for (r(t.value, t.key, this); t && t.removed;) t = t.previous;
        },
        has: function has(e) {
          return !!s(this, e);
        }
      }), vc(i, n ? {
        get: function get(e) {
          var t = s(this, e);
          return t && t.value;
        },
        set: function set(e, t) {
          return a(this, 0 === e ? 0 : e, t);
        }
      } : {
        add: function add(e) {
          return a(this, e = 0 === e ? 0 : e, e);
        }
      }), v && bc(i, "size", {
        get: function get() {
          return c(this).size;
        }
      }), o;
    },
    setStrong: function setStrong(e, t, n) {
      var r = t + " Iterator",
        o = Sc(t),
        i = Sc(r);
      Qo(e, t, function (e, t) {
        wc(this, {
          type: r,
          target: e,
          state: o(e),
          kind: t,
          last: void 0
        });
      }, function () {
        for (var e = i(this), t = e.kind, n = e.last; n && n.removed;) n = n.previous;
        return e.target && (e.last = n = n ? n.next : e.state.first) ? qo("keys" == t ? n.key : "values" == t ? n.value : [n.key, n.value], !1) : (e.target = void 0, qo(void 0, !0));
      }, n ? "entries" : "values", !n, !0), function (e) {
        var t = z(e),
          n = Je.f;
        v && t && !t[mc] && n(t, mc, {
          configurable: !0,
          get: function get() {
            return this;
          }
        });
      }(t);
    }
  };
function _c(e) {
  var t = this.constructor;
  return this.then(function (n) {
    return t.resolve(e()).then(function () {
      return n;
    });
  }, function (n) {
    return t.resolve(e()).then(function () {
      return t.reject(n);
    });
  });
}
function Ic(e) {
  return new this(function (t, n) {
    if (!e || void 0 === e.length) return n(new TypeError(typeof e + " " + e + " is not iterable(cannot read property Symbol(Symbol.iterator))"));
    var r = Array.prototype.slice.call(e);
    if (0 === r.length) return t([]);
    var o = r.length;
    function i(e, n) {
      if (n && ("object" == typeof n || "function" == typeof n)) {
        var c = n.then;
        if ("function" == typeof c) return void c.call(n, function (t) {
          i(e, t);
        }, function (n) {
          r[e] = {
            status: "rejected",
            reason: n
          }, 0 == --o && t(r);
        });
      }
      r[e] = {
        status: "fulfilled",
        value: n
      }, 0 == --o && t(r);
    }
    for (var c = 0; c < r.length; c++) i(c, r[c]);
  });
}
!function (e, t, n) {
  var r = -1 !== e.indexOf("Map"),
    o = -1 !== e.indexOf("Weak"),
    i = r ? "set" : "add",
    c = p[e],
    a = c && c.prototype,
    s = c,
    u = {},
    l = function l(e) {
      var t = L(a[e]);
      mt(a, e, "add" == e ? function (e) {
        return t(this, 0 === e ? 0 : e), this;
      } : "delete" == e ? function (e) {
        return !(o && !J(e)) && t(this, 0 === e ? 0 : e);
      } : "get" == e ? function (e) {
        return o && !J(e) ? void 0 : t(this, 0 === e ? 0 : e);
      } : "has" == e ? function (e) {
        return !(o && !J(e)) && t(this, 0 === e ? 0 : e);
      } : function (e, n) {
        return t(this, 0 === e ? 0 : e, n), this;
      });
    };
  if (Jt(e, !H(c) || !(o || a.forEach && !y(function () {
    new c().entries().next();
  })))) s = n.getConstructor(t, e, r, i), uc.enable();else if (Jt(e, !0)) {
    var f = new s(),
      d = f[i](o ? {} : -0, 1) != f,
      h = y(function () {
        f.has(1);
      }),
      v = vi(function (e) {
        new c(e);
      }),
      m = !o && y(function () {
        for (var e = new c(), t = 5; t--;) e[i](t, t);
        return !e.has(-0);
      });
    v || ((s = t(function (e, t) {
      yc(e, a);
      var n = function (e, t, n) {
        var r, o;
        return Ho && H(r = t.constructor) && r !== n && J(o = r.prototype) && o !== n.prototype && Ho(e, o), e;
      }(new c(), e, s);
      return P(t) || hc(t, n[i], {
        that: n,
        AS_ENTRIES: r
      }), n;
    })).prototype = a, a.constructor = s), (h || m) && (l("delete"), l("has"), r && l("get")), (m || d) && l(i), o && a.clear && delete a.clear;
  }
  u[e] = s, zt({
    global: !0,
    constructor: !0,
    forced: s != c
  }, u), lr(s, e), o || n.setStrong(s, e, r);
}("Set", function (e) {
  return function () {
    return e(this, arguments.length ? arguments[0] : void 0);
  };
}, kc), or.Set;
var Oc = setTimeout;
function xc(e) {
  return Boolean(e && void 0 !== e.length);
}
function Tc() {}
function Cc(e) {
  if (!(this instanceof Cc)) throw new TypeError("Promises must be constructed via new");
  if ("function" != typeof e) throw new TypeError("not a function");
  this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], Ec(e, this);
}
function jc(e, t) {
  for (; 3 === e._state;) e = e._value;
  0 !== e._state ? (e._handled = !0, Cc._immediateFn(function () {
    var n = 1 === e._state ? t.onFulfilled : t.onRejected;
    if (null !== n) {
      var r;
      try {
        r = n(e._value);
      } catch (e) {
        return void Rc(t.promise, e);
      }
      Lc(t.promise, r);
    } else (1 === e._state ? Lc : Rc)(t.promise, e._value);
  })) : e._deferreds.push(t);
}
function Lc(e, t) {
  try {
    if (t === e) throw new TypeError("A promise cannot be resolved with itself.");
    if (t && ("object" == typeof t || "function" == typeof t)) {
      var n = t.then;
      if (t instanceof Cc) return e._state = 3, e._value = t, void Wc(e);
      if ("function" == typeof n) return void Ec((r = n, o = t, function () {
        r.apply(o, arguments);
      }), e);
    }
    e._state = 1, e._value = t, Wc(e);
  } catch (t) {
    Rc(e, t);
  }
  var r, o;
}
function Rc(e, t) {
  e._state = 2, e._value = t, Wc(e);
}
function Wc(e) {
  2 === e._state && 0 === e._deferreds.length && Cc._immediateFn(function () {
    e._handled || Cc._unhandledRejectionFn(e._value);
  });
  for (var t = 0, n = e._deferreds.length; t < n; t++) jc(e, e._deferreds[t]);
  e._deferreds = null;
}
function Zc(e, t, n) {
  this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
}
function Ec(e, t) {
  var n = !1;
  try {
    e(function (e) {
      n || (n = !0, Lc(t, e));
    }, function (e) {
      n || (n = !0, Rc(t, e));
    });
  } catch (e) {
    if (n) return;
    n = !0, Rc(t, e);
  }
}
Cc.prototype.catch = function (e) {
  return this.then(null, e);
}, Cc.prototype.then = function (e, t) {
  var n = new this.constructor(Tc);
  return jc(this, new Zc(e, t, n)), n;
}, Cc.prototype.finally = _c, Cc.all = function (e) {
  return new Cc(function (t, n) {
    if (!xc(e)) return n(new TypeError("Promise.all accepts an array"));
    var r = Array.prototype.slice.call(e);
    if (0 === r.length) return t([]);
    var o = r.length;
    function i(e, c) {
      try {
        if (c && ("object" == typeof c || "function" == typeof c)) {
          var a = c.then;
          if ("function" == typeof a) return void a.call(c, function (t) {
            i(e, t);
          }, n);
        }
        r[e] = c, 0 == --o && t(r);
      } catch (e) {
        n(e);
      }
    }
    for (var c = 0; c < r.length; c++) i(c, r[c]);
  });
}, Cc.allSettled = Ic, Cc.resolve = function (e) {
  return e && "object" == typeof e && e.constructor === Cc ? e : new Cc(function (t) {
    t(e);
  });
}, Cc.reject = function (e) {
  return new Cc(function (t, n) {
    n(e);
  });
}, Cc.race = function (e) {
  return new Cc(function (t, n) {
    if (!xc(e)) return n(new TypeError("Promise.race accepts an array"));
    for (var r = 0, o = e.length; r < o; r++) Cc.resolve(e[r]).then(t, n);
  });
}, Cc._immediateFn = "function" == typeof setImmediate && function (e) {
  setImmediate(e);
} || function (e) {
  Oc(e, 0);
}, Cc._unhandledRejectionFn = function (e) {
  "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
};
var Gc = function () {
  if ("undefined" != typeof self) return self;
  if ("undefined" != typeof window) return window;
  if ("undefined" != typeof global) return global;
  throw new Error("unable to locate global object");
}();
"function" != typeof Gc.Promise ? Gc.Promise = Cc : (Gc.Promise.prototype.finally || (Gc.Promise.prototype.finally = _c), Gc.Promise.allSettled || (Gc.Promise.allSettled = Ic)), function (e) {
  function t(e) {
    for (var t = 0, n = Math.min(65536, e.length + 1), r = new Uint16Array(n), o = [], i = 0;;) {
      var c = t < e.length;
      if (!c || i >= n - 1) {
        var a = r.subarray(0, i);
        if (o.push(String.fromCharCode.apply(null, a)), !c) return o.join("");
        e = e.subarray(t), t = 0, i = 0;
      }
      var s = e[t++];
      if (0 == (128 & s)) r[i++] = s;else if (192 == (224 & s)) {
        var u = 63 & e[t++];
        r[i++] = (31 & s) << 6 | u;
      } else if (224 == (240 & s)) {
        u = 63 & e[t++];
        var l = 63 & e[t++];
        r[i++] = (31 & s) << 12 | u << 6 | l;
      } else if (240 == (248 & s)) {
        var f = (7 & s) << 18 | (u = 63 & e[t++]) << 12 | (l = 63 & e[t++]) << 6 | 63 & e[t++];
        f > 65535 && (f -= 65536, r[i++] = f >>> 10 & 1023 | 55296, f = 56320 | 1023 & f), r[i++] = f;
      }
    }
  }
  var n = "Failed to ",
    r = function r(e, t, _r2) {
      if (e) throw new Error("".concat(n).concat(t, ": the '").concat(_r2, "' option is unsupported."));
    },
    o = "function" == typeof Buffer && Buffer.from,
    i = o ? function (e) {
      return Buffer.from(e);
    } : function (e) {
      for (var t = 0, n = e.length, r = 0, o = Math.max(32, n + (n >>> 1) + 7), i = new Uint8Array(o >>> 3 << 3); t < n;) {
        var c = e.charCodeAt(t++);
        if (c >= 55296 && c <= 56319) {
          if (t < n) {
            var a = e.charCodeAt(t);
            56320 == (64512 & a) && (++t, c = ((1023 & c) << 10) + (1023 & a) + 65536);
          }
          if (c >= 55296 && c <= 56319) continue;
        }
        if (r + 4 > i.length) {
          o += 8, o = (o *= 1 + t / e.length * 2) >>> 3 << 3;
          var s = new Uint8Array(o);
          s.set(i), i = s;
        }
        if (0 != (4294967168 & c)) {
          if (0 == (4294965248 & c)) i[r++] = c >>> 6 & 31 | 192;else if (0 == (4294901760 & c)) i[r++] = c >>> 12 & 15 | 224, i[r++] = c >>> 6 & 63 | 128;else {
            if (0 != (4292870144 & c)) continue;
            i[r++] = c >>> 18 & 7 | 240, i[r++] = c >>> 12 & 63 | 128, i[r++] = c >>> 6 & 63 | 128;
          }
          i[r++] = 63 & c | 128;
        } else i[r++] = c;
      }
      return i.slice ? i.slice(0, r) : i.subarray(0, r);
    };
  function c() {
    this.encoding = "utf-8";
  }
  c.prototype.encode = function (e, t) {
    return r(t && t.stream, "encode", "stream"), i(e);
  };
  var a = !o && "function" == typeof Blob && "function" == typeof URL && "function" == typeof URL.createObjectURL,
    s = ["utf-8", "utf8", "unicode-1-1-utf-8"],
    u = t;
  o ? u = function u(e, t) {
    return (e instanceof Buffer ? e : Buffer.from(e.buffer, e.byteOffset, e.byteLength)).toString(t);
  } : a && (u = function u(e) {
    try {
      return function (e) {
        var t;
        try {
          var n = new Blob([e], {
            type: "text/plain;charset=UTF-8"
          });
          t = URL.createObjectURL(n);
          var r = new XMLHttpRequest();
          return r.open("GET", t, !1), r.send(), r.responseText;
        } finally {
          t && URL.revokeObjectURL(t);
        }
      }(e);
    } catch (n) {
      return t(e);
    }
  });
  var l = "construct 'TextDecoder'",
    f = "".concat(n, " ").concat(l, ": the ");
  function d(e, t) {
    if (r(t && t.fatal, l, "fatal"), e = e || "utf-8", !(o ? Buffer.isEncoding(e) : -1 !== s.indexOf(e.toLowerCase()))) throw new RangeError("".concat(f, " encoding label provided ('").concat(e, "') is invalid."));
    this.encoding = e, this.fatal = !1, this.ignoreBOM = !1;
  }
  d.prototype.decode = function (e, t) {
    var n;
    return r(t && t.stream, "decode", "stream"), n = e instanceof Uint8Array ? e : e.buffer instanceof ArrayBuffer ? new Uint8Array(e.buffer) : new Uint8Array(e), u(n, this.encoding);
  }, e.TextEncoder = e.TextEncoder || c, e.TextDecoder = e.TextDecoder || d;
}("undefined" != typeof window ? window : s), function () {
  function e(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
  }
  function t(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }
  function n(e, n, r) {
    return n && t(e.prototype, n), r && t(e, r), e;
  }
  function r(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && i(e, t);
  }
  function o(e) {
    return o = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    }, o(e);
  }
  function i(e, t) {
    return i = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    }, i(e, t);
  }
  function c() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
    } catch (e) {
      return !1;
    }
  }
  function a(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function u(e, t) {
    return !t || "object" != typeof t && "function" != typeof t ? a(e) : t;
  }
  function l(e) {
    var t = c();
    return function () {
      var n,
        r = o(e);
      if (t) {
        var i = o(this).constructor;
        n = Reflect.construct(r, arguments, i);
      } else n = r.apply(this, arguments);
      return u(this, n);
    };
  }
  function f(e, t) {
    for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = o(e)););
    return e;
  }
  function d(e, t, n) {
    return d = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function (e, t, n) {
      var r = f(e, t);
      if (r) {
        var o = Object.getOwnPropertyDescriptor(r, t);
        return o.get ? o.get.call(n) : o.value;
      }
    }, d(e, t, n || e);
  }
  var h = function () {
      function t() {
        e(this, t), Object.defineProperty(this, "listeners", {
          value: {},
          writable: !0,
          configurable: !0
        });
      }
      return n(t, [{
        key: "addEventListener",
        value: function value(e, t, n) {
          e in this.listeners || (this.listeners[e] = []), this.listeners[e].push({
            callback: t,
            options: n
          });
        }
      }, {
        key: "removeEventListener",
        value: function value(e, t) {
          if (e in this.listeners) for (var n = this.listeners[e], r = 0, o = n.length; r < o; r++) if (n[r].callback === t) return void n.splice(r, 1);
        }
      }, {
        key: "dispatchEvent",
        value: function value(e) {
          var _this2 = this;
          if (e.type in this.listeners) {
            var _loop = function _loop() {
                o = t[n];
                try {
                  o.callback.call(_this2, e);
                } catch (e) {
                  Promise.resolve().then(function () {
                    throw e;
                  });
                }
                o.options && o.options.once && _this2.removeEventListener(e.type, o.callback);
              },
              o;
            for (var t = this.listeners[e.type].slice(), n = 0, r = t.length; n < r; n++) {
              _loop();
            }
            return !e.defaultPrevented;
          }
        }
      }]), t;
    }(),
    p = function (t) {
      r(c, t);
      var i = l(c);
      function c() {
        var t;
        return e(this, c), (t = i.call(this)).listeners || h.call(a(t)), Object.defineProperty(a(t), "aborted", {
          value: !1,
          writable: !0,
          configurable: !0
        }), Object.defineProperty(a(t), "onabort", {
          value: null,
          writable: !0,
          configurable: !0
        }), t;
      }
      return n(c, [{
        key: "toString",
        value: function value() {
          return "[object AbortSignal]";
        }
      }, {
        key: "dispatchEvent",
        value: function value(e) {
          "abort" === e.type && (this.aborted = !0, "function" == typeof this.onabort && this.onabort.call(this, e)), d(o(c.prototype), "dispatchEvent", this).call(this, e);
        }
      }]), c;
    }(h),
    y = function () {
      function t() {
        e(this, t), Object.defineProperty(this, "signal", {
          value: new p(),
          writable: !0,
          configurable: !0
        });
      }
      return n(t, [{
        key: "abort",
        value: function value() {
          var e;
          try {
            e = new Event("abort");
          } catch (t) {
            "undefined" != typeof document ? document.createEvent ? (e = document.createEvent("Event")).initEvent("abort", !1, !1) : (e = document.createEventObject()).type = "abort" : e = {
              type: "abort",
              bubbles: !1,
              cancelable: !1
            };
          }
          this.signal.dispatchEvent(e);
        }
      }, {
        key: "toString",
        value: function value() {
          return "[object AbortController]";
        }
      }]), t;
    }();
  function v(e) {
    return e.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL ? (console.log("__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill"), !0) : "function" == typeof e.Request && !e.Request.prototype.hasOwnProperty("signal") || !e.AbortController;
  }
  "undefined" != typeof Symbol && Symbol.toStringTag && (y.prototype[Symbol.toStringTag] = "AbortController", p.prototype[Symbol.toStringTag] = "AbortSignal"), function (e) {
    v(e) && (e.AbortController = y, e.AbortSignal = p);
  }("undefined" != typeof self ? self : s);
}();
var Ac = l(function (e, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  var n = function () {
    function e() {
      var e = this;
      this.locked = new Map(), this.addToLocked = function (t, n) {
        var r = e.locked.get(t);
        void 0 === r ? void 0 === n ? e.locked.set(t, []) : e.locked.set(t, [n]) : void 0 !== n && (r.unshift(n), e.locked.set(t, r));
      }, this.isLocked = function (t) {
        return e.locked.has(t);
      }, this.lock = function (t) {
        return new Promise(function (n, r) {
          e.isLocked(t) ? e.addToLocked(t, n) : (e.addToLocked(t), n());
        });
      }, this.unlock = function (t) {
        var n = e.locked.get(t);
        if (void 0 !== n && 0 !== n.length) {
          var r = n.pop();
          e.locked.set(t, n), void 0 !== r && setTimeout(r, 0);
        } else e.locked.delete(t);
      };
    }
    return e.getInstance = function () {
      return void 0 === e.instance && (e.instance = new e()), e.instance;
    }, e;
  }();
  t.default = function () {
    return n.getInstance();
  };
});
u(Ac);
var Pc = l(function (e, t) {
    var n = s && s.__awaiter || function (e, t, n, r) {
        return new (n || (n = Promise))(function (o, i) {
          function c(e) {
            try {
              s(r.next(e));
            } catch (e) {
              i(e);
            }
          }
          function a(e) {
            try {
              s(r.throw(e));
            } catch (e) {
              i(e);
            }
          }
          function s(e) {
            e.done ? o(e.value) : new n(function (t) {
              t(e.value);
            }).then(c, a);
          }
          s((r = r.apply(e, t || [])).next());
        });
      },
      r = s && s.__generator || function (e, t) {
        var n,
          r,
          o,
          i,
          c = {
            label: 0,
            sent: function sent() {
              if (1 & o[0]) throw o[1];
              return o[1];
            },
            trys: [],
            ops: []
          };
        return i = {
          next: a(0),
          throw: a(1),
          return: a(2)
        }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
          return this;
        }), i;
        function a(i) {
          return function (a) {
            return function (i) {
              if (n) throw new TypeError("Generator is already executing.");
              for (; c;) try {
                if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;
                switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
                  case 0:
                  case 1:
                    o = i;
                    break;
                  case 4:
                    return c.label++, {
                      value: i[1],
                      done: !1
                    };
                  case 5:
                    c.label++, r = i[1], i = [0];
                    continue;
                  case 7:
                    i = c.ops.pop(), c.trys.pop();
                    continue;
                  default:
                    if (!(o = c.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                      c = 0;
                      continue;
                    }
                    if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                      c.label = i[1];
                      break;
                    }
                    if (6 === i[0] && c.label < o[1]) {
                      c.label = o[1], o = i;
                      break;
                    }
                    if (o && c.label < o[2]) {
                      c.label = o[2], c.ops.push(i);
                      break;
                    }
                    o[2] && c.ops.pop(), c.trys.pop();
                    continue;
                }
                i = t.call(e, c);
              } catch (e) {
                i = [6, e], r = 0;
              } finally {
                n = o = 0;
              }
              if (5 & i[0]) throw i[1];
              return {
                value: i[0] ? i[1] : void 0,
                done: !0
              };
            }([i, a]);
          };
        }
      };
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var o = "browser-tabs-lock-key";
    function i(e) {
      return new Promise(function (t) {
        return setTimeout(t, e);
      });
    }
    function c(e) {
      for (var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", n = "", r = 0; r < e; r++) {
        n += t[Math.floor(Math.random() * t.length)];
      }
      return n;
    }
    var a = function () {
      function e() {
        this.acquiredIatSet = new Set(), this.id = Date.now().toString() + c(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), void 0 === e.waiters && (e.waiters = []);
      }
      return e.prototype.acquireLock = function (t, a) {
        return void 0 === a && (a = 5e3), n(this, void 0, void 0, function () {
          var n, s, u, l, f, d;
          return r(this, function (r) {
            switch (r.label) {
              case 0:
                n = Date.now() + c(4), s = Date.now() + a, u = o + "-" + t, l = window.localStorage, r.label = 1;
              case 1:
                return Date.now() < s ? [4, i(30)] : [3, 8];
              case 2:
                return r.sent(), null !== l.getItem(u) ? [3, 5] : (f = this.id + "-" + t + "-" + n, [4, i(Math.floor(25 * Math.random()))]);
              case 3:
                return r.sent(), l.setItem(u, JSON.stringify({
                  id: this.id,
                  iat: n,
                  timeoutKey: f,
                  timeAcquired: Date.now(),
                  timeRefreshed: Date.now()
                })), [4, i(30)];
              case 4:
                return r.sent(), null !== (d = l.getItem(u)) && (d = JSON.parse(d)).id === this.id && d.iat === n ? (this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(u, n), [2, !0]) : [3, 7];
              case 5:
                return e.lockCorrector(), [4, this.waitForSomethingToChange(s)];
              case 6:
                r.sent(), r.label = 7;
              case 7:
                return n = Date.now() + c(4), [3, 1];
              case 8:
                return [2, !1];
            }
          });
        });
      }, e.prototype.refreshLockWhileAcquired = function (e, t) {
        return n(this, void 0, void 0, function () {
          var o = this;
          return r(this, function (i) {
            return setTimeout(function () {
              return n(o, void 0, void 0, function () {
                var n, o;
                return r(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return [4, Ac.default().lock(t)];
                    case 1:
                      return r.sent(), this.acquiredIatSet.has(t) ? (n = window.localStorage, null === (o = n.getItem(e)) ? (Ac.default().unlock(t), [2]) : ((o = JSON.parse(o)).timeRefreshed = Date.now(), n.setItem(e, JSON.stringify(o)), Ac.default().unlock(t), this.refreshLockWhileAcquired(e, t), [2])) : (Ac.default().unlock(t), [2]);
                  }
                });
              });
            }, 1e3), [2];
          });
        });
      }, e.prototype.waitForSomethingToChange = function (t) {
        return n(this, void 0, void 0, function () {
          return r(this, function (n) {
            switch (n.label) {
              case 0:
                return [4, new Promise(function (n) {
                  var r = !1,
                    o = Date.now(),
                    i = !1;
                  function c() {
                    if (i || (window.removeEventListener("storage", c), e.removeFromWaiting(c), clearTimeout(a), i = !0), !r) {
                      r = !0;
                      var t = 50 - (Date.now() - o);
                      t > 0 ? setTimeout(n, t) : n();
                    }
                  }
                  window.addEventListener("storage", c), e.addToWaiting(c);
                  var a = setTimeout(c, Math.max(0, t - Date.now()));
                })];
              case 1:
                return n.sent(), [2];
            }
          });
        });
      }, e.addToWaiting = function (t) {
        this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
      }, e.removeFromWaiting = function (t) {
        void 0 !== e.waiters && (e.waiters = e.waiters.filter(function (e) {
          return e !== t;
        }));
      }, e.notifyWaiters = function () {
        void 0 !== e.waiters && e.waiters.slice().forEach(function (e) {
          return e();
        });
      }, e.prototype.releaseLock = function (e) {
        return n(this, void 0, void 0, function () {
          return r(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, this.releaseLock__private__(e)];
              case 1:
                return [2, t.sent()];
            }
          });
        });
      }, e.prototype.releaseLock__private__ = function (t) {
        return n(this, void 0, void 0, function () {
          var n, i, c;
          return r(this, function (r) {
            switch (r.label) {
              case 0:
                return n = window.localStorage, i = o + "-" + t, null === (c = n.getItem(i)) ? [2] : (c = JSON.parse(c)).id !== this.id ? [3, 2] : [4, Ac.default().lock(c.iat)];
              case 1:
                r.sent(), this.acquiredIatSet.delete(c.iat), n.removeItem(i), Ac.default().unlock(c.iat), e.notifyWaiters(), r.label = 2;
              case 2:
                return [2];
            }
          });
        });
      }, e.lockCorrector = function () {
        for (var t = Date.now() - 5e3, n = window.localStorage, r = Object.keys(n), i = !1, c = 0; c < r.length; c++) {
          var a = r[c];
          if (a.includes(o)) {
            var s = n.getItem(a);
            null !== s && (void 0 === (s = JSON.parse(s)).timeRefreshed && s.timeAcquired < t || void 0 !== s.timeRefreshed && s.timeRefreshed < t) && (n.removeItem(a), i = !0);
          }
        }
        i && e.notifyWaiters();
      }, e.waiters = void 0, e;
    }();
    t.default = a;
  }),
  Xc = u(Pc),
  Fc = {
    timeoutInSeconds: 60
  },
  Kc = ["login_required", "consent_required", "interaction_required", "account_selection_required", "access_denied"],
  Nc = {
    name: "auth0-spa-js",
    version: "1.22.6"
  },
  Uc = function Uc() {
    return Date.now();
  },
  Dc = function (e) {
    function n(t, r) {
      var o = e.call(this, r) || this;
      return o.error = t, o.error_description = r, Object.setPrototypeOf(o, n.prototype), o;
    }
    return t(n, e), n.fromPayload = function (e) {
      return new n(e.error, e.error_description);
    }, n;
  }(Error),
  Hc = function (e) {
    function n(t, r, o, i) {
      void 0 === i && (i = null);
      var c = e.call(this, t, r) || this;
      return c.state = o, c.appState = i, Object.setPrototypeOf(c, n.prototype), c;
    }
    return t(n, e), n;
  }(Dc),
  Yc = function (e) {
    function n() {
      var t = e.call(this, "timeout", "Timeout") || this;
      return Object.setPrototypeOf(t, n.prototype), t;
    }
    return t(n, e), n;
  }(Dc),
  Jc = function (e) {
    function n(t) {
      var r = e.call(this) || this;
      return r.popup = t, Object.setPrototypeOf(r, n.prototype), r;
    }
    return t(n, e), n;
  }(Yc),
  Vc = function (e) {
    function n(t) {
      var r = e.call(this, "cancelled", "Popup closed") || this;
      return r.popup = t, Object.setPrototypeOf(r, n.prototype), r;
    }
    return t(n, e), n;
  }(Dc),
  zc = function (e) {
    function n(t, r, o) {
      var i = e.call(this, t, r) || this;
      return i.mfa_token = o, Object.setPrototypeOf(i, n.prototype), i;
    }
    return t(n, e), n;
  }(Dc),
  Mc = function (e) {
    function n(t, r) {
      var o = e.call(this, "missing_refresh_token", "Missing Refresh Token (audience: '".concat(ia(t, ["default"]), "', scope: '").concat(ia(r), "')")) || this;
      return o.audience = t, o.scope = r, Object.setPrototypeOf(o, n.prototype), o;
    }
    return t(n, e), n;
  }(Dc),
  Bc = function Bc(e) {
    return new Promise(function (t, n) {
      var _r3,
        o = setInterval(function () {
          e.popup && e.popup.closed && (clearInterval(o), clearTimeout(i), window.removeEventListener("message", _r3, !1), n(new Vc(e.popup)));
        }, 1e3),
        i = setTimeout(function () {
          clearInterval(o), n(new Jc(e.popup)), window.removeEventListener("message", _r3, !1);
        }, 1e3 * (e.timeoutInSeconds || 60));
      _r3 = function r(c) {
        if (c.data && "authorization_response" === c.data.type) {
          if (clearTimeout(i), clearInterval(o), window.removeEventListener("message", _r3, !1), e.popup.close(), c.data.response.error) return n(Dc.fromPayload(c.data.response));
          t(c.data.response);
        }
      }, window.addEventListener("message", _r3);
    });
  },
  Qc = function Qc() {
    return window.crypto || window.msCrypto;
  },
  qc = function qc() {
    var e = Qc();
    return e.subtle || e.webkitSubtle;
  },
  $c = function $c() {
    var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.",
      t = "";
    return Array.from(Qc().getRandomValues(new Uint8Array(43))).forEach(function (n) {
      return t += e[n % e.length];
    }), t;
  },
  ea = function ea(e) {
    return btoa(e);
  },
  ta = function ta(e) {
    return Object.keys(e).filter(function (t) {
      return void 0 !== e[t];
    }).map(function (t) {
      return encodeURIComponent(t) + "=" + encodeURIComponent(e[t]);
    }).join("&");
  },
  na = function na(e) {
    return o(void 0, void 0, void 0, function () {
      var t;
      return i(this, function (n) {
        switch (n.label) {
          case 0:
            return t = qc().digest({
              name: "SHA-256"
            }, new TextEncoder().encode(e)), window.msCrypto ? [2, new Promise(function (e, n) {
              t.oncomplete = function (t) {
                e(t.target.result);
              }, t.onerror = function (e) {
                n(e.error);
              }, t.onabort = function () {
                n("The digest operation was aborted");
              };
            })] : [4, t];
          case 1:
            return [2, n.sent()];
        }
      });
    });
  },
  ra = function ra(e) {
    return function (e) {
      return decodeURIComponent(atob(e).split("").map(function (e) {
        return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
    }(e.replace(/_/g, "/").replace(/-/g, "+"));
  },
  oa = function oa(e) {
    var t = new Uint8Array(e);
    return function (e) {
      var t = {
        "+": "-",
        "/": "_",
        "=": ""
      };
      return e.replace(/[+/=]/g, function (e) {
        return t[e];
      });
    }(window.btoa(String.fromCharCode.apply(String, a([], c(Array.from(t)), !1))));
  };
function ia(e, t) {
  return void 0 === t && (t = []), e && !t.includes(e) ? e : "";
}
var ca = function ca(e, t) {
    return o(void 0, void 0, void 0, function () {
      var n, r;
      return i(this, function (o) {
        switch (o.label) {
          case 0:
            return [4, (i = e, c = t, c = c || {}, new Promise(function (e, t) {
              var n = new XMLHttpRequest(),
                r = [],
                o = [],
                a = {},
                _s = function s() {
                  return {
                    ok: 2 == (n.status / 100 | 0),
                    statusText: n.statusText,
                    status: n.status,
                    url: n.responseURL,
                    text: function text() {
                      return Promise.resolve(n.responseText);
                    },
                    json: function json() {
                      return Promise.resolve(n.responseText).then(JSON.parse);
                    },
                    blob: function blob() {
                      return Promise.resolve(new Blob([n.response]));
                    },
                    clone: _s,
                    headers: {
                      keys: function keys() {
                        return r;
                      },
                      entries: function entries() {
                        return o;
                      },
                      get: function get(e) {
                        return a[e.toLowerCase()];
                      },
                      has: function has(e) {
                        return e.toLowerCase() in a;
                      }
                    }
                  };
                };
              for (var u in n.open(c.method || "get", i, !0), n.onload = function () {
                n.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, t, n) {
                  r.push(t = t.toLowerCase()), o.push([t, n]), a[t] = a[t] ? a[t] + "," + n : n;
                }), e(_s());
              }, n.onerror = t, n.withCredentials = "include" == c.credentials, c.headers) n.setRequestHeader(u, c.headers[u]);
              n.send(c.body || null);
            }))];
          case 1:
            return n = o.sent(), r = {
              ok: n.ok
            }, [4, n.json()];
          case 2:
            return [2, (r.json = o.sent(), r)];
        }
        var i, c;
      });
    });
  },
  aa = function aa(e, t, n) {
    return o(void 0, void 0, void 0, function () {
      var r, o;
      return i(this, function (i) {
        return r = new AbortController(), t.signal = r.signal, [2, Promise.race([ca(e, t), new Promise(function (e, t) {
          o = setTimeout(function () {
            r.abort(), t(new Error("Timeout when executing 'fetch'"));
          }, n);
        })]).finally(function () {
          clearTimeout(o);
        })];
      });
    });
  },
  sa = function sa(e, t, n, r, c, a, s) {
    return o(void 0, void 0, void 0, function () {
      return i(this, function (o) {
        return [2, (i = {
          auth: {
            audience: t,
            scope: n
          },
          timeout: c,
          fetchUrl: e,
          fetchOptions: r,
          useFormData: s
        }, u = a, new Promise(function (e, t) {
          var n = new MessageChannel();
          n.port1.onmessage = function (r) {
            r.data.error ? t(new Error(r.data.error)) : e(r.data), n.port1.close();
          }, u.postMessage(i, [n.port2]);
        }))];
        var i, u;
      });
    });
  },
  ua = function ua(e, t, n, r, c, a, s) {
    return void 0 === s && (s = 1e4), o(void 0, void 0, void 0, function () {
      return i(this, function (o) {
        return c ? [2, sa(e, t, n, r, s, c, a)] : [2, aa(e, r, s)];
      });
    });
  };
function la(e, t, n, c, a, s, u) {
  return o(this, void 0, void 0, function () {
    var o, l, f, d, h, p, y, v, m;
    return i(this, function (i) {
      switch (i.label) {
        case 0:
          o = null, f = 0, i.label = 1;
        case 1:
          if (!(f < 3)) return [3, 6];
          i.label = 2;
        case 2:
          return i.trys.push([2, 4,, 5]), [4, ua(e, n, c, a, s, u, t)];
        case 3:
          return l = i.sent(), o = null, [3, 6];
        case 4:
          return d = i.sent(), o = d, [3, 5];
        case 5:
          return f++, [3, 1];
        case 6:
          if (o) throw o.message = o.message || "Failed to fetch", o;
          if (h = l.json, p = h.error, y = h.error_description, v = r(h, ["error", "error_description"]), !l.ok) {
            if (m = y || "HTTP error. Unable to fetch ".concat(e), "mfa_required" === p) throw new zc(p, m, v.mfa_token);
            throw new Dc(p || "request_error", m);
          }
          return [2, v];
      }
    });
  });
}
function fa(e, t) {
  var n = e.baseUrl,
    c = e.timeout,
    a = e.audience,
    s = e.scope,
    u = e.auth0Client,
    l = e.useFormData,
    f = r(e, ["baseUrl", "timeout", "audience", "scope", "auth0Client", "useFormData"]);
  return o(this, void 0, void 0, function () {
    var e;
    return i(this, function (r) {
      switch (r.label) {
        case 0:
          return e = l ? ta(f) : JSON.stringify(f), [4, la("".concat(n, "/oauth/token"), c, a || "default", s, {
            method: "POST",
            body: e,
            headers: {
              "Content-Type": l ? "application/x-www-form-urlencoded" : "application/json",
              "Auth0-Client": btoa(JSON.stringify(u || Nc))
            }
          }, t, l)];
        case 1:
          return [2, r.sent()];
      }
    });
  });
}
var da = function da(e) {
    return Array.from(new Set(e));
  },
  ha = function ha() {
    for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
    return da(e.join(" ").trim().split(/\s+/)).join(" ");
  },
  pa = function () {
    function e(e, t) {
      void 0 === t && (t = "@@auth0spajs@@"), this.prefix = t, this.client_id = e.client_id, this.scope = e.scope, this.audience = e.audience;
    }
    return e.prototype.toKey = function () {
      return "".concat(this.prefix, "::").concat(this.client_id, "::").concat(this.audience, "::").concat(this.scope);
    }, e.fromKey = function (t) {
      var n = c(t.split("::"), 4),
        r = n[0],
        o = n[1],
        i = n[2];
      return new e({
        client_id: o,
        scope: n[3],
        audience: i
      }, r);
    }, e.fromCacheEntry = function (t) {
      return new e({
        scope: t.scope,
        audience: t.audience,
        client_id: t.client_id
      });
    }, e;
  }(),
  ya = function () {
    function e() {}
    return e.prototype.set = function (e, t) {
      localStorage.setItem(e, JSON.stringify(t));
    }, e.prototype.get = function (e) {
      var t = window.localStorage.getItem(e);
      if (t) try {
        return JSON.parse(t);
      } catch (e) {
        return;
      }
    }, e.prototype.remove = function (e) {
      localStorage.removeItem(e);
    }, e.prototype.allKeys = function () {
      return Object.keys(window.localStorage).filter(function (e) {
        return e.startsWith("@@auth0spajs@@");
      });
    }, e;
  }(),
  va = function va() {
    var e;
    this.enclosedCache = (e = {}, {
      set: function set(t, n) {
        e[t] = n;
      },
      get: function get(t) {
        var n = e[t];
        if (n) return n;
      },
      remove: function remove(t) {
        delete e[t];
      },
      allKeys: function allKeys() {
        return Object.keys(e);
      }
    });
  },
  ma = function () {
    function e(e, t, n) {
      this.cache = e, this.keyManifest = t, this.nowProvider = n, this.nowProvider = this.nowProvider || Uc;
    }
    return e.prototype.get = function (e, t) {
      var n;
      return void 0 === t && (t = 0), o(this, void 0, void 0, function () {
        var r, o, c, a, s;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, this.cache.get(e.toKey())];
            case 1:
              return (r = i.sent()) ? [3, 4] : [4, this.getCacheKeys()];
            case 2:
              return (o = i.sent()) ? (c = this.matchExistingCacheKey(e, o)) ? [4, this.cache.get(c)] : [3, 4] : [2];
            case 3:
              r = i.sent(), i.label = 4;
            case 4:
              return r ? [4, this.nowProvider()] : [2];
            case 5:
              return a = i.sent(), s = Math.floor(a / 1e3), r.expiresAt - t < s ? r.body.refresh_token ? (r.body = {
                refresh_token: r.body.refresh_token
              }, [4, this.cache.set(e.toKey(), r)]) : [3, 7] : [3, 10];
            case 6:
              return i.sent(), [2, r.body];
            case 7:
              return [4, this.cache.remove(e.toKey())];
            case 8:
              return i.sent(), [4, null === (n = this.keyManifest) || void 0 === n ? void 0 : n.remove(e.toKey())];
            case 9:
              return i.sent(), [2];
            case 10:
              return [2, r.body];
          }
        });
      });
    }, e.prototype.set = function (e) {
      var t;
      return o(this, void 0, void 0, function () {
        var n, r;
        return i(this, function (o) {
          switch (o.label) {
            case 0:
              return n = new pa({
                client_id: e.client_id,
                scope: e.scope,
                audience: e.audience
              }), [4, this.wrapCacheEntry(e)];
            case 1:
              return r = o.sent(), [4, this.cache.set(n.toKey(), r)];
            case 2:
              return o.sent(), [4, null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(n.toKey())];
            case 3:
              return o.sent(), [2];
          }
        });
      });
    }, e.prototype.clear = function (e) {
      var t;
      return o(this, void 0, void 0, function () {
        var n,
          r = this;
        return i(this, function (c) {
          switch (c.label) {
            case 0:
              return [4, this.getCacheKeys()];
            case 1:
              return (n = c.sent()) ? [4, n.filter(function (t) {
                return !e || t.includes(e);
              }).reduce(function (e, t) {
                return o(r, void 0, void 0, function () {
                  return i(this, function (n) {
                    switch (n.label) {
                      case 0:
                        return [4, e];
                      case 1:
                        return n.sent(), [4, this.cache.remove(t)];
                      case 2:
                        return n.sent(), [2];
                    }
                  });
                });
              }, Promise.resolve())] : [2];
            case 2:
              return c.sent(), [4, null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()];
            case 3:
              return c.sent(), [2];
          }
        });
      });
    }, e.prototype.clearSync = function (e) {
      var t = this,
        n = this.cache.allKeys();
      n && n.filter(function (t) {
        return !e || t.includes(e);
      }).forEach(function (e) {
        t.cache.remove(e);
      });
    }, e.prototype.wrapCacheEntry = function (e) {
      return o(this, void 0, void 0, function () {
        var t, n, r;
        return i(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, this.nowProvider()];
            case 1:
              return t = o.sent(), n = Math.floor(t / 1e3) + e.expires_in, r = Math.min(n, e.decodedToken.claims.exp), [2, {
                body: e,
                expiresAt: r
              }];
          }
        });
      });
    }, e.prototype.getCacheKeys = function () {
      var e;
      return o(this, void 0, void 0, function () {
        var t;
        return i(this, function (n) {
          switch (n.label) {
            case 0:
              return this.keyManifest ? [4, this.keyManifest.get()] : [3, 2];
            case 1:
              return t = null === (e = n.sent()) || void 0 === e ? void 0 : e.keys, [3, 4];
            case 2:
              return [4, this.cache.allKeys()];
            case 3:
              t = n.sent(), n.label = 4;
            case 4:
              return [2, t];
          }
        });
      });
    }, e.prototype.matchExistingCacheKey = function (e, t) {
      return t.filter(function (t) {
        var n = pa.fromKey(t),
          r = new Set(n.scope && n.scope.split(" ")),
          o = e.scope.split(" "),
          i = n.scope && o.reduce(function (e, t) {
            return e && r.has(t);
          }, !0);
        return "@@auth0spajs@@" === n.prefix && n.client_id === e.client_id && n.audience === e.audience && i;
      })[0];
    }, e;
  }(),
  ba = function () {
    function e(e, t) {
      this.storage = e, this.clientId = t, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId), this.transaction = this.storage.get(this.storageKey);
    }
    return e.prototype.create = function (e) {
      this.transaction = e, this.storage.save(this.storageKey, e, {
        daysUntilExpire: 1
      });
    }, e.prototype.get = function () {
      return this.transaction;
    }, e.prototype.remove = function () {
      delete this.transaction, this.storage.remove(this.storageKey);
    }, e;
  }(),
  ga = function ga(e) {
    return "number" == typeof e;
  },
  wa = ["iss", "aud", "exp", "nbf", "iat", "jti", "azp", "nonce", "auth_time", "at_hash", "c_hash", "acr", "amr", "sub_jwk", "cnf", "sip_from_tag", "sip_date", "sip_callid", "sip_cseq_num", "sip_via_branch", "orig", "dest", "mky", "events", "toe", "txn", "rph", "sid", "vot", "vtm"],
  Sa = function Sa(e) {
    if (!e.id_token) throw new Error("ID token is required but missing");
    var t = function (e) {
      var t = e.split("."),
        n = c(t, 3),
        r = n[0],
        o = n[1],
        i = n[2];
      if (3 !== t.length || !r || !o || !i) throw new Error("ID token could not be decoded");
      var a = JSON.parse(ra(o)),
        s = {
          __raw: e
        },
        u = {};
      return Object.keys(a).forEach(function (e) {
        s[e] = a[e], wa.includes(e) || (u[e] = a[e]);
      }), {
        encoded: {
          header: r,
          payload: o,
          signature: i
        },
        header: JSON.parse(ra(r)),
        claims: s,
        user: u
      };
    }(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
      if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
      if (t.claims.aud.length > 1) {
        if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
        if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
      }
    } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
    if (e.nonce) {
      if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
      if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
    }
    if (e.max_age && !ga(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (!ga(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!ga(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    var n = e.leeway || 60,
      r = new Date(e.now || Date.now()),
      o = new Date(0),
      i = new Date(0),
      a = new Date(0);
    if (a.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), o.setUTCSeconds(t.claims.exp + n), i.setUTCSeconds(t.claims.nbf - n), r > o) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(r, ") is after expiration time (").concat(o, ")"));
    if (ga(t.claims.nbf) && r < i) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Currrent time (".concat(r, ") is before ").concat(i));
    if (ga(t.claims.auth_time) && r > a) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Currrent time (".concat(r, ") is after last auth at ").concat(a));
    if (e.organizationId) {
      if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
      if (e.organizationId !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(e.organizationId, '", found "').concat(t.claims.org_id, '"'));
    }
    return t;
  },
  ka = l(function (e, t) {
    var n = s && s.__assign || function () {
      return n = Object.assign || function (e) {
        for (var t, n = 1, r = arguments.length; n < r; n++) for (var o in t = arguments[n]) Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        return e;
      }, n.apply(this, arguments);
    };
    function r(e, t) {
      if (!t) return "";
      var n = "; " + e;
      return !0 === t ? n : n + "=" + t;
    }
    function o(e, t, n) {
      return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function (e) {
        if ("number" == typeof e.expires) {
          var t = new Date();
          t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
        }
        return r("Expires", e.expires ? e.expires.toUTCString() : "") + r("Domain", e.domain) + r("Path", e.path) + r("Secure", e.secure) + r("SameSite", e.sameSite);
      }(n);
    }
    function i(e) {
      for (var t = {}, n = e ? e.split("; ") : [], r = /(%[\dA-F]{2})+/gi, o = 0; o < n.length; o++) {
        var i = n[o].split("="),
          c = i.slice(1).join("=");
        '"' === c.charAt(0) && (c = c.slice(1, -1));
        try {
          t[i[0].replace(r, decodeURIComponent)] = c.replace(r, decodeURIComponent);
        } catch (e) {}
      }
      return t;
    }
    function c() {
      return i(document.cookie);
    }
    function a(e, t, r) {
      document.cookie = o(e, t, n({
        path: "/"
      }, r));
    }
    t.__esModule = !0, t.encode = o, t.parse = i, t.getAll = c, t.get = function (e) {
      return c()[e];
    }, t.set = a, t.remove = function (e, t) {
      a(e, "", n(n({}, t), {
        expires: -1
      }));
    };
  });
u(ka), ka.encode, ka.parse, ka.getAll;
var _a = ka.get,
  Ia = ka.set,
  Oa = ka.remove,
  xa = {
    get: function get(e) {
      var t = _a(e);
      if (void 0 !== t) return JSON.parse(t);
    },
    save: function save(e, t, n) {
      var r = {};
      "https:" === window.location.protocol && (r = {
        secure: !0,
        sameSite: "none"
      }), (null == n ? void 0 : n.daysUntilExpire) && (r.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (r.domain = n.cookieDomain), Ia(e, JSON.stringify(t), r);
    },
    remove: function remove(e, t) {
      var n = {};
      (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), Oa(e, n);
    }
  },
  Ta = {
    get: function get(e) {
      var t = xa.get(e);
      return t || xa.get("".concat("_legacy_").concat(e));
    },
    save: function save(e, t, n) {
      var r = {};
      "https:" === window.location.protocol && (r = {
        secure: !0
      }), (null == n ? void 0 : n.daysUntilExpire) && (r.expires = n.daysUntilExpire), Ia("".concat("_legacy_").concat(e), JSON.stringify(t), r), xa.save(e, t, n);
    },
    remove: function remove(e, t) {
      var n = {};
      (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), Oa(e, n), xa.remove(e, t), xa.remove("".concat("_legacy_").concat(e), t);
    }
  },
  Ca = {
    get: function get(e) {
      if ("undefined" != typeof sessionStorage) {
        var t = sessionStorage.getItem(e);
        if (void 0 !== t) return JSON.parse(t);
      }
    },
    save: function save(e, t) {
      sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove: function remove(e) {
      sessionStorage.removeItem(e);
    }
  };
function ja(e, t, n) {
  var r = void 0 === t ? null : t,
    o = function (e, t) {
      var n = atob(e);
      if (t) {
        for (var r = new Uint8Array(n.length), o = 0, i = n.length; o < i; ++o) r[o] = n.charCodeAt(o);
        return String.fromCharCode.apply(null, new Uint16Array(r.buffer));
      }
      return n;
    }(e, void 0 !== n && n),
    i = o.indexOf("\n", 10) + 1,
    c = o.substring(i) + (r ? "//# sourceMappingURL=" + r : ""),
    a = new Blob([c], {
      type: "application/javascript"
    });
  return URL.createObjectURL(a);
}
var La,
  Ra,
  Wa,
  Za,
  Ea = (La = "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", Ra = null, Wa = !1, function (e) {
    return Za = Za || ja(La, Ra, Wa), new Worker(Za, e);
  }),
  Ga = {},
  Aa = function () {
    function e(e, t) {
      this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    return e.prototype.add = function (e) {
      var t;
      return o(this, void 0, void 0, function () {
        var n, r;
        return i(this, function (o) {
          switch (o.label) {
            case 0:
              return r = Set.bind, [4, this.cache.get(this.manifestKey)];
            case 1:
              return (n = new (r.apply(Set, [void 0, (null === (t = o.sent()) || void 0 === t ? void 0 : t.keys) || []]))()).add(e), [4, this.cache.set(this.manifestKey, {
                keys: a([], c(n), !1)
              })];
            case 2:
              return o.sent(), [2];
          }
        });
      });
    }, e.prototype.remove = function (e) {
      return o(this, void 0, void 0, function () {
        var t, n;
        return i(this, function (r) {
          switch (r.label) {
            case 0:
              return [4, this.cache.get(this.manifestKey)];
            case 1:
              return (t = r.sent()) ? ((n = new Set(t.keys)).delete(e), n.size > 0 ? [4, this.cache.set(this.manifestKey, {
                keys: a([], c(n), !1)
              })] : [3, 3]) : [3, 5];
            case 2:
            case 4:
              return [2, r.sent()];
            case 3:
              return [4, this.cache.remove(this.manifestKey)];
            case 5:
              return [2];
          }
        });
      });
    }, e.prototype.get = function () {
      return this.cache.get(this.manifestKey);
    }, e.prototype.clear = function () {
      return this.cache.remove(this.manifestKey);
    }, e.prototype.createManifestKeyFrom = function (e) {
      return "".concat("@@auth0spajs@@", "::").concat(e);
    }, e;
  }(),
  Pa = new Xc(),
  Xa = {
    memory: function memory() {
      return new va().enclosedCache;
    },
    localstorage: function localstorage() {
      return new ya();
    }
  },
  Fa = function Fa(e) {
    return Xa[e];
  },
  Ka = function Ka() {
    return !/Trident.*rv:11\.0/.test(navigator.userAgent);
  },
  Na = function () {
    function e(e) {
      var t,
        n,
        c,
        a,
        s = this;
      if (this.options = e, this._releaseLockOnPageHide = function () {
        return o(s, void 0, void 0, function () {
          return i(this, function (e) {
            switch (e.label) {
              case 0:
                return [4, Pa.releaseLock("auth0.lock.getTokenSilently")];
              case 1:
                return e.sent(), window.removeEventListener("pagehide", this._releaseLockOnPageHide), [2];
            }
          });
        });
      }, "undefined" != typeof window && function () {
        if (!Qc()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
        if (void 0 === qc()) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/master/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
      }(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) c = e.cache;else {
        if (this.cacheLocation = e.cacheLocation || "memory", !Fa(this.cacheLocation)) throw new Error('Invalid cache location "'.concat(this.cacheLocation, '"'));
        c = Fa(this.cacheLocation)();
      }
      this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? xa : Ta, this.orgHintCookieName = (a = this.options.client_id, "auth0.".concat(a, ".organization_hint")), this.isAuthenticatedCookieName = function (e) {
        return "auth0.".concat(e, ".is.authenticated");
      }(this.options.client_id), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
      var u,
        l = e.useCookiesForTransactions ? this.cookieStorage : Ca;
      this.scope = this.options.scope, this.transactionManager = new ba(l, this.options.client_id), this.nowProvider = this.options.nowProvider || Uc, this.cacheManager = new ma(c, c.allKeys ? null : new Aa(c, this.options.client_id), this.nowProvider), this.domainUrl = (u = this.options.domain, /^https?:\/\//.test(u) ? u : "https://".concat(u)), this.tokenIssuer = function (e, t) {
        return e ? e.startsWith("https://") ? e : "https://".concat(e, "/") : "".concat(t, "/");
      }(this.options.issuer, this.domainUrl), this.defaultScope = ha("openid", void 0 !== (null === (n = null === (t = this.options) || void 0 === t ? void 0 : t.advancedOptions) || void 0 === n ? void 0 : n.defaultScope) ? this.options.advancedOptions.defaultScope : "openid profile email"), this.options.useRefreshTokens && (this.scope = ha(this.scope, "offline_access")), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === this.cacheLocation && Ka() && (this.worker = new Ea()), this.customOptions = function (e) {
        return e.advancedOptions, e.audience, e.auth0Client, e.authorizeTimeoutInSeconds, e.cacheLocation, e.cache, e.client_id, e.domain, e.issuer, e.leeway, e.max_age, e.nowProvider, e.redirect_uri, e.scope, e.useRefreshTokens, e.useRefreshTokensFallback, e.useCookiesForTransactions, e.useFormData, r(e, ["advancedOptions", "audience", "auth0Client", "authorizeTimeoutInSeconds", "cacheLocation", "cache", "client_id", "domain", "issuer", "leeway", "max_age", "nowProvider", "redirect_uri", "scope", "useRefreshTokens", "useRefreshTokensFallback", "useCookiesForTransactions", "useFormData"]);
      }(e), this.useRefreshTokensFallback = !1 !== this.options.useRefreshTokensFallback;
    }
    return e.prototype._url = function (e) {
      var t = encodeURIComponent(btoa(JSON.stringify(this.options.auth0Client || Nc)));
      return "".concat(this.domainUrl).concat(e, "&auth0Client=").concat(t);
    }, e.prototype._getParams = function (e, t, o, i, c) {
      var a = this.options;
      a.useRefreshTokens, a.useCookiesForTransactions, a.useFormData, a.auth0Client, a.cacheLocation, a.advancedOptions, a.detailedResponse, a.nowProvider, a.authorizeTimeoutInSeconds, a.legacySameSiteCookie, a.sessionCheckExpiryDays, a.domain, a.leeway, a.httpTimeoutInSeconds;
      var s = r(a, ["useRefreshTokens", "useCookiesForTransactions", "useFormData", "auth0Client", "cacheLocation", "advancedOptions", "detailedResponse", "nowProvider", "authorizeTimeoutInSeconds", "legacySameSiteCookie", "sessionCheckExpiryDays", "domain", "leeway", "httpTimeoutInSeconds"]);
      return _n2(_n2(_n2({}, s), e), {
        scope: ha(this.defaultScope, this.scope, e.scope),
        response_type: "code",
        response_mode: "query",
        state: t,
        nonce: o,
        redirect_uri: c || this.options.redirect_uri,
        code_challenge: i,
        code_challenge_method: "S256"
      });
    }, e.prototype._authorizeUrl = function (e) {
      return this._url("/authorize?".concat(ta(e)));
    }, e.prototype._verifyIdToken = function (e, t, n) {
      return o(this, void 0, void 0, function () {
        var r;
        return i(this, function (o) {
          switch (o.label) {
            case 0:
              return [4, this.nowProvider()];
            case 1:
              return r = o.sent(), [2, Sa({
                iss: this.tokenIssuer,
                aud: this.options.client_id,
                id_token: e,
                nonce: t,
                organizationId: n,
                leeway: this.options.leeway,
                max_age: this._parseNumber(this.options.max_age),
                now: r
              })];
          }
        });
      });
    }, e.prototype._parseNumber = function (e) {
      return "string" != typeof e ? e : parseInt(e, 10) || void 0;
    }, e.prototype._processOrgIdHint = function (e) {
      e ? this.cookieStorage.save(this.orgHintCookieName, e, {
        daysUntilExpire: this.sessionCheckExpiryDays,
        cookieDomain: this.options.cookieDomain
      }) : this.cookieStorage.remove(this.orgHintCookieName, {
        cookieDomain: this.options.cookieDomain
      });
    }, e.prototype.buildAuthorizeUrl = function (e) {
      return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
        var t, o, c, a, s, u, l, f, d, h, p, y;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return t = e.redirect_uri, o = e.appState, c = r(e, ["redirect_uri", "appState"]), a = ea($c()), s = ea($c()), u = $c(), [4, na(u)];
            case 1:
              return l = i.sent(), f = oa(l), d = e.fragment ? "#".concat(e.fragment) : "", h = this._getParams(c, a, s, f, t), p = this._authorizeUrl(h), y = e.organization || this.options.organization, this.transactionManager.create(_n2({
                nonce: s,
                code_verifier: u,
                appState: o,
                scope: h.scope,
                audience: h.audience || "default",
                redirect_uri: h.redirect_uri,
                state: a
              }, y && {
                organizationId: y
              })), [2, p + d];
          }
        });
      });
    }, e.prototype.loginWithPopup = function (e, t) {
      return o(this, void 0, void 0, function () {
        var o, c, a, s, u, l, f, d, h, p, y, v, m;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              if (e = e || {}, !(t = t || {}).popup && (t.popup = function (e) {
                var t = window.screenX + (window.innerWidth - 400) / 2,
                  n = window.screenY + (window.innerHeight - 600) / 2;
                return window.open(e, "auth0:authorize:popup", "left=".concat(t, ",top=").concat(n, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
              }(""), !t.popup)) throw new Error("Unable to open a popup for loginWithPopup - window.open returned `null`");
              return o = r(e, []), c = ea($c()), a = ea($c()), s = $c(), [4, na(s)];
            case 1:
              return u = i.sent(), l = oa(u), f = this._getParams(o, c, a, l, this.options.redirect_uri || window.location.origin), d = this._authorizeUrl(_n2(_n2({}, f), {
                response_mode: "web_message"
              })), t.popup.location.href = d, [4, Bc(_n2(_n2({}, t), {
                timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
              }))];
            case 2:
              if (h = i.sent(), c !== h.state) throw new Error("Invalid state");
              return [4, fa({
                audience: f.audience,
                scope: f.scope,
                baseUrl: this.domainUrl,
                client_id: this.options.client_id,
                code_verifier: s,
                code: h.code,
                grant_type: "authorization_code",
                redirect_uri: f.redirect_uri,
                auth0Client: this.options.auth0Client,
                useFormData: this.options.useFormData,
                timeout: this.httpTimeoutMs
              }, this.worker)];
            case 3:
              return p = i.sent(), y = e.organization || this.options.organization, [4, this._verifyIdToken(p.id_token, a, y)];
            case 4:
              return v = i.sent(), m = _n2(_n2({}, p), {
                decodedToken: v,
                scope: f.scope,
                audience: f.audience || "default",
                client_id: this.options.client_id
              }), [4, this.cacheManager.set(m)];
            case 5:
              return i.sent(), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
              }), this._processOrgIdHint(v.claims.org_id), [2];
          }
        });
      });
    }, e.prototype.getUser = function (e) {
      return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
        var t, n, r;
        return i(this, function (o) {
          switch (o.label) {
            case 0:
              return t = e.audience || this.options.audience || "default", n = ha(this.defaultScope, this.scope, e.scope), [4, this.cacheManager.get(new pa({
                client_id: this.options.client_id,
                audience: t,
                scope: n
              }))];
            case 1:
              return [2, (r = o.sent()) && r.decodedToken && r.decodedToken.user];
          }
        });
      });
    }, e.prototype.getIdTokenClaims = function (e) {
      return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
        var t, n, r;
        return i(this, function (o) {
          switch (o.label) {
            case 0:
              return t = e.audience || this.options.audience || "default", n = ha(this.defaultScope, this.scope, e.scope), [4, this.cacheManager.get(new pa({
                client_id: this.options.client_id,
                audience: t,
                scope: n
              }))];
            case 1:
              return [2, (r = o.sent()) && r.decodedToken && r.decodedToken.claims];
          }
        });
      });
    }, e.prototype.loginWithRedirect = function (e) {
      return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
        var t, n, o;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return t = e.redirectMethod, n = r(e, ["redirectMethod"]), [4, this.buildAuthorizeUrl(n)];
            case 1:
              return o = i.sent(), window.location[t || "assign"](o), [2];
          }
        });
      });
    }, e.prototype.handleRedirectCallback = function (e) {
      return void 0 === e && (e = window.location.href), o(this, void 0, void 0, function () {
        var t, r, o, a, s, u, l, f, d, h;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              if (0 === (t = e.split("?").slice(1)).length) throw new Error("There are no query params available for parsing.");
              if (r = function (e) {
                e.indexOf("#") > -1 && (e = e.substr(0, e.indexOf("#")));
                var t = e.split("&"),
                  n = {};
                return t.forEach(function (e) {
                  var t = c(e.split("="), 2),
                    r = t[0],
                    o = t[1];
                  n[r] = decodeURIComponent(o);
                }), n.expires_in && (n.expires_in = parseInt(n.expires_in)), n;
              }(t.join("")), o = r.state, a = r.code, s = r.error, u = r.error_description, !(l = this.transactionManager.get())) throw new Error("Invalid state");
              if (this.transactionManager.remove(), s) throw new Hc(s, u, o, l.appState);
              if (!l.code_verifier || l.state && l.state !== o) throw new Error("Invalid state");
              return f = {
                audience: l.audience,
                scope: l.scope,
                baseUrl: this.domainUrl,
                client_id: this.options.client_id,
                code_verifier: l.code_verifier,
                grant_type: "authorization_code",
                code: a,
                auth0Client: this.options.auth0Client,
                useFormData: this.options.useFormData,
                timeout: this.httpTimeoutMs
              }, void 0 !== l.redirect_uri && (f.redirect_uri = l.redirect_uri), [4, fa(f, this.worker)];
            case 1:
              return d = i.sent(), [4, this._verifyIdToken(d.id_token, l.nonce, l.organizationId)];
            case 2:
              return h = i.sent(), [4, this.cacheManager.set(_n2(_n2(_n2(_n2({}, d), {
                decodedToken: h,
                audience: l.audience,
                scope: l.scope
              }), d.scope ? {
                oauthTokenScope: d.scope
              } : null), {
                client_id: this.options.client_id
              }))];
            case 3:
              return i.sent(), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
              }), this._processOrgIdHint(h.claims.org_id), [2, {
                appState: l.appState
              }];
          }
        });
      });
    }, e.prototype.checkSession = function (e) {
      return o(this, void 0, void 0, function () {
        var t;
        return i(this, function (n) {
          switch (n.label) {
            case 0:
              if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
                if (!this.cookieStorage.get("auth0.is.authenticated")) return [2];
                this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                  daysUntilExpire: this.sessionCheckExpiryDays,
                  cookieDomain: this.options.cookieDomain
                }), this.cookieStorage.remove("auth0.is.authenticated");
              }
              n.label = 1;
            case 1:
              return n.trys.push([1, 3,, 4]), [4, this.getTokenSilently(e)];
            case 2:
              return n.sent(), [3, 4];
            case 3:
              if (t = n.sent(), !Kc.includes(t.error)) throw t;
              return [3, 4];
            case 4:
              return [2];
          }
        });
      });
    }, e.prototype.getTokenSilently = function (e) {
      return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
        var t,
          o,
          c,
          a,
          s = this;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return t = _n2(_n2({
                audience: this.options.audience,
                ignoreCache: !1
              }, e), {
                scope: ha(this.defaultScope, this.scope, e.scope)
              }), o = t.ignoreCache, c = r(t, ["ignoreCache"]), [4, (u = function u() {
                return s._getTokenSilently(_n2({
                  ignoreCache: o
                }, c));
              }, l = "".concat(this.options.client_id, "::").concat(c.audience, "::").concat(c.scope), f = Ga[l], f || (f = u().finally(function () {
                delete Ga[l], f = null;
              }), Ga[l] = f), f)];
            case 1:
              return a = i.sent(), [2, e.detailedResponse ? a : a.access_token];
          }
          var u, l, f;
        });
      });
    }, e.prototype._getTokenSilently = function (e) {
      return void 0 === e && (e = {}), o(this, void 0, void 0, function () {
        var t, c, a, s, u, l, f, d, h;
        return i(this, function (p) {
          switch (p.label) {
            case 0:
              return t = e.ignoreCache, c = r(e, ["ignoreCache"]), t ? [3, 2] : [4, this._getEntryFromCache({
                scope: c.scope,
                audience: c.audience || "default",
                client_id: this.options.client_id
              })];
            case 1:
              if (a = p.sent()) return [2, a];
              p.label = 2;
            case 2:
              return [4, (y = function y() {
                return Pa.acquireLock("auth0.lock.getTokenSilently", 5e3);
              }, v = 10, void 0 === v && (v = 3), o(void 0, void 0, void 0, function () {
                var e;
                return i(this, function (t) {
                  switch (t.label) {
                    case 0:
                      e = 0, t.label = 1;
                    case 1:
                      return e < v ? [4, y()] : [3, 4];
                    case 2:
                      if (t.sent()) return [2, !0];
                      t.label = 3;
                    case 3:
                      return e++, [3, 1];
                    case 4:
                      return [2, !1];
                  }
                });
              }))];
            case 3:
              if (!p.sent()) return [3, 15];
              p.label = 4;
            case 4:
              return p.trys.push([4,, 12, 14]), window.addEventListener("pagehide", this._releaseLockOnPageHide), t ? [3, 6] : [4, this._getEntryFromCache({
                scope: c.scope,
                audience: c.audience || "default",
                client_id: this.options.client_id
              })];
            case 5:
              if (a = p.sent()) return [2, a];
              p.label = 6;
            case 6:
              return this.options.useRefreshTokens ? [4, this._getTokenUsingRefreshToken(c)] : [3, 8];
            case 7:
              return u = p.sent(), [3, 10];
            case 8:
              return [4, this._getTokenFromIFrame(c)];
            case 9:
              u = p.sent(), p.label = 10;
            case 10:
              return s = u, [4, this.cacheManager.set(_n2({
                client_id: this.options.client_id
              }, s))];
            case 11:
              return p.sent(), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
              }), l = s.id_token, f = s.access_token, d = s.oauthTokenScope, h = s.expires_in, [2, _n2(_n2({
                id_token: l,
                access_token: f
              }, d ? {
                scope: d
              } : null), {
                expires_in: h
              })];
            case 12:
              return [4, Pa.releaseLock("auth0.lock.getTokenSilently")];
            case 13:
              return p.sent(), window.removeEventListener("pagehide", this._releaseLockOnPageHide), [7];
            case 14:
              return [3, 16];
            case 15:
              throw new Yc();
            case 16:
              return [2];
          }
          var y, v;
        });
      });
    }, e.prototype.getTokenWithPopup = function (e, t) {
      return void 0 === e && (e = {}), void 0 === t && (t = {}), o(this, void 0, void 0, function () {
        return i(this, function (r) {
          switch (r.label) {
            case 0:
              return e.audience = e.audience || this.options.audience, e.scope = ha(this.defaultScope, this.scope, e.scope), t = _n2(_n2({}, Fc), t), [4, this.loginWithPopup(e, t)];
            case 1:
              return r.sent(), [4, this.cacheManager.get(new pa({
                scope: e.scope,
                audience: e.audience || "default",
                client_id: this.options.client_id
              }))];
            case 2:
              return [2, r.sent().access_token];
          }
        });
      });
    }, e.prototype.isAuthenticated = function () {
      return o(this, void 0, void 0, function () {
        return i(this, function (e) {
          switch (e.label) {
            case 0:
              return [4, this.getUser()];
            case 1:
              return [2, !!e.sent()];
          }
        });
      });
    }, e.prototype.buildLogoutUrl = function (e) {
      void 0 === e && (e = {}), null !== e.client_id ? e.client_id = e.client_id || this.options.client_id : delete e.client_id;
      var t = e.federated,
        n = r(e, ["federated"]),
        o = t ? "&federated" : "";
      return this._url("/v2/logout?".concat(ta(n))) + o;
    }, e.prototype.logout = function (e) {
      var t = this;
      void 0 === e && (e = {});
      var n = e.localOnly,
        o = r(e, ["localOnly"]);
      if (n && o.federated) throw new Error("It is invalid to set both the `federated` and `localOnly` options to `true`");
      var i = function i() {
        if (t.cookieStorage.remove(t.orgHintCookieName, {
          cookieDomain: t.options.cookieDomain
        }), t.cookieStorage.remove(t.isAuthenticatedCookieName, {
          cookieDomain: t.options.cookieDomain
        }), !n) {
          var e = t.buildLogoutUrl(o);
          window.location.assign(e);
        }
      };
      if (this.options.cache) return this.cacheManager.clear().then(function () {
        return i();
      });
      this.cacheManager.clearSync(), i();
    }, e.prototype._getTokenFromIFrame = function (e) {
      return o(this, void 0, void 0, function () {
        var t, o, c, a, s, u, l, f, d, h, p, y, v, m, b, g, w;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return t = ea($c()), o = ea($c()), c = $c(), [4, na(c)];
            case 1:
              a = i.sent(), s = oa(a), u = r(e, ["detailedResponse"]), l = this._getParams(u, t, o, s, e.redirect_uri || this.options.redirect_uri || window.location.origin), (f = this.cookieStorage.get(this.orgHintCookieName)) && !l.organization && (l.organization = f), d = this._authorizeUrl(_n2(_n2({}, l), {
                prompt: "none",
                response_mode: "web_message"
              })), i.label = 2;
            case 2:
              if (i.trys.push([2, 6,, 7]), window.crossOriginIsolated) throw new Dc("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
              return h = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds, [4, (S = d, k = this.domainUrl, _ = h, void 0 === _ && (_ = 60), new Promise(function (e, t) {
                var n = window.document.createElement("iframe");
                n.setAttribute("width", "0"), n.setAttribute("height", "0"), n.style.display = "none";
                var _r4,
                  o = function o() {
                    window.document.body.contains(n) && (window.document.body.removeChild(n), window.removeEventListener("message", _r4, !1));
                  },
                  i = setTimeout(function () {
                    t(new Yc()), o();
                  }, 1e3 * _);
                _r4 = function r(n) {
                  if (n.origin == k && n.data && "authorization_response" === n.data.type) {
                    var c = n.source;
                    c && c.close(), n.data.response.error ? t(Dc.fromPayload(n.data.response)) : e(n.data.response), clearTimeout(i), window.removeEventListener("message", _r4, !1), setTimeout(o, 2e3);
                  }
                }, window.addEventListener("message", _r4, !1), window.document.body.appendChild(n), n.setAttribute("src", S);
              }))];
            case 3:
              if (p = i.sent(), t !== p.state) throw new Error("Invalid state");
              return y = e.scope, v = e.audience, m = r(e, ["scope", "audience", "redirect_uri", "ignoreCache", "timeoutInSeconds", "detailedResponse"]), [4, fa(_n2(_n2(_n2({}, this.customOptions), m), {
                scope: y,
                audience: v,
                baseUrl: this.domainUrl,
                client_id: this.options.client_id,
                code_verifier: c,
                code: p.code,
                grant_type: "authorization_code",
                redirect_uri: l.redirect_uri,
                auth0Client: this.options.auth0Client,
                useFormData: this.options.useFormData,
                timeout: m.timeout || this.httpTimeoutMs
              }), this.worker)];
            case 4:
              return b = i.sent(), [4, this._verifyIdToken(b.id_token, o)];
            case 5:
              return g = i.sent(), this._processOrgIdHint(g.claims.org_id), [2, _n2(_n2({}, b), {
                decodedToken: g,
                scope: l.scope,
                oauthTokenScope: b.scope,
                audience: l.audience || "default"
              })];
            case 6:
              throw "login_required" === (w = i.sent()).error && this.logout({
                localOnly: !0
              }), w;
            case 7:
              return [2];
          }
          var S, k, _;
        });
      });
    }, e.prototype._getTokenUsingRefreshToken = function (e) {
      return o(this, void 0, void 0, function () {
        var t, o, c, a, s, u, l, f, d;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return e.scope = ha(this.defaultScope, this.options.scope, e.scope), [4, this.cacheManager.get(new pa({
                scope: e.scope,
                audience: e.audience || "default",
                client_id: this.options.client_id
              }))];
            case 1:
              return (t = i.sent()) && t.refresh_token || this.worker ? [3, 4] : this.useRefreshTokensFallback ? [4, this._getTokenFromIFrame(e)] : [3, 3];
            case 2:
              return [2, i.sent()];
            case 3:
              throw new Mc(e.audience || "default", e.scope);
            case 4:
              o = e.redirect_uri || this.options.redirect_uri || window.location.origin, a = e.scope, s = e.audience, u = r(e, ["scope", "audience", "ignoreCache", "timeoutInSeconds", "detailedResponse"]), l = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, i.label = 5;
            case 5:
              return i.trys.push([5, 7,, 10]), [4, fa(_n2(_n2(_n2(_n2(_n2({}, this.customOptions), u), {
                audience: s,
                scope: a,
                baseUrl: this.domainUrl,
                client_id: this.options.client_id,
                grant_type: "refresh_token",
                refresh_token: t && t.refresh_token,
                redirect_uri: o
              }), l && {
                timeout: l
              }), {
                auth0Client: this.options.auth0Client,
                useFormData: this.options.useFormData,
                timeout: this.httpTimeoutMs
              }), this.worker)];
            case 6:
              return c = i.sent(), [3, 10];
            case 7:
              return ((f = i.sent()).message.indexOf("Missing Refresh Token") > -1 || f.message && f.message.indexOf("invalid refresh token") > -1) && this.useRefreshTokensFallback ? [4, this._getTokenFromIFrame(e)] : [3, 9];
            case 8:
              return [2, i.sent()];
            case 9:
              throw f;
            case 10:
              return [4, this._verifyIdToken(c.id_token)];
            case 11:
              return d = i.sent(), [2, _n2(_n2({}, c), {
                decodedToken: d,
                scope: e.scope,
                oauthTokenScope: c.scope,
                audience: e.audience || "default"
              })];
          }
        });
      });
    }, e.prototype._getEntryFromCache = function (e) {
      var t = e.scope,
        r = e.audience,
        c = e.client_id;
      return o(this, void 0, void 0, function () {
        var e, o, a, s, u;
        return i(this, function (i) {
          switch (i.label) {
            case 0:
              return [4, this.cacheManager.get(new pa({
                scope: t,
                audience: r,
                client_id: c
              }), 60)];
            case 1:
              return (e = i.sent()) && e.access_token ? (o = e.id_token, a = e.access_token, s = e.oauthTokenScope, u = e.expires_in, [2, _n2(_n2({
                id_token: o,
                access_token: a
              }, s ? {
                scope: s
              } : null), {
                expires_in: u
              })]) : [2];
          }
        });
      });
    }, e;
  }(),
  Ua = function Ua() {};

/**
 * The initial auth state.
 */
var initialAuthState = {
  isAuthenticated: false,
  isLoading: true
};

/**
 * @ignore
 */
var stub = function stub() {
  throw new Error('You forgot to wrap your component in <Auth0Provider>.');
};
/**
 * @ignore
 */
var initialContext = _assign(_assign({}, initialAuthState), {
  buildAuthorizeUrl: stub,
  buildLogoutUrl: stub,
  getAccessTokenSilently: stub,
  getAccessTokenWithPopup: stub,
  getIdTokenClaims: stub,
  loginWithRedirect: stub,
  loginWithPopup: stub,
  logout: stub,
  handleRedirectCallback: stub
});
/**
 * The Auth0 Context
 */
var Auth0Context = createContext(initialContext);

/**
 * An OAuth2 error will come from the authorization server and will have at least an `error` property which will
 * be the error code. And possibly an `error_description` property
 *
 * See: https://openid.net/specs/openid-connect-core-1_0.html#rfc.section.3.1.2.6
 */
var OAuthError = /** @class */function (_super) {
  __extends(OAuthError, _super);
  function OAuthError(error, error_description) {
    var _this = _super.call(this, error_description || error) || this;
    _this.error = error;
    _this.error_description = error_description;
    // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
    Object.setPrototypeOf(_this, OAuthError.prototype);
    return _this;
  }
  return OAuthError;
}(Error);
var CODE_RE = /[?&]code=[^&]+/;
var STATE_RE = /[?&]state=[^&]+/;
var ERROR_RE = /[?&]error=[^&]+/;
var hasAuthParams = function hasAuthParams(searchParams) {
  if (searchParams === void 0) {
    searchParams = window.location.search;
  }
  return (CODE_RE.test(searchParams) || ERROR_RE.test(searchParams)) && STATE_RE.test(searchParams);
};
var normalizeErrorFn = function normalizeErrorFn(fallbackMessage) {
  return function (error) {
    if ('error' in error) {
      return new OAuthError(error.error, error.error_description);
    }
    if (error instanceof Error) {
      return error;
    }
    return new Error(fallbackMessage);
  };
};
var loginError = normalizeErrorFn('Login failed');
var tokenError = normalizeErrorFn('Get access token failed');

/**
 * Handles how that state changes in the `useAuth0` hook.
 */
var reducer = function reducer(state, action) {
  var _a, _b;
  switch (action.type) {
    case 'LOGIN_POPUP_STARTED':
      return _assign(_assign({}, state), {
        isLoading: true
      });
    case 'LOGIN_POPUP_COMPLETE':
    case 'INITIALISED':
      return _assign(_assign({}, state), {
        isAuthenticated: !!action.user,
        user: action.user,
        isLoading: false,
        error: undefined
      });
    case 'HANDLE_REDIRECT_COMPLETE':
    case 'GET_ACCESS_TOKEN_COMPLETE':
      if (((_a = state.user) === null || _a === void 0 ? void 0 : _a.updated_at) === ((_b = action.user) === null || _b === void 0 ? void 0 : _b.updated_at)) {
        return state;
      }
      return _assign(_assign({}, state), {
        isAuthenticated: !!action.user,
        user: action.user
      });
    case 'LOGOUT':
      return _assign(_assign({}, state), {
        isAuthenticated: false,
        user: undefined
      });
    case 'ERROR':
      return _assign(_assign({}, state), {
        isLoading: false,
        error: action.error
      });
  }
};

/**
 * @ignore
 */
var toAuth0ClientOptions = function toAuth0ClientOptions(opts) {
  var clientId = opts.clientId,
    redirectUri = opts.redirectUri,
    maxAge = opts.maxAge,
    validOpts = __rest(opts, ["clientId", "redirectUri", "maxAge"]);
  return _assign(_assign({}, validOpts), {
    client_id: clientId,
    redirect_uri: redirectUri,
    max_age: maxAge,
    auth0Client: {
      name: 'auth0-react',
      version: '1.12.1'
    }
  });
};
/**
 * @ignore
 */
var toAuth0LoginRedirectOptions = function toAuth0LoginRedirectOptions(opts) {
  if (!opts) {
    return;
  }
  var redirectUri = opts.redirectUri,
    validOpts = __rest(opts, ["redirectUri"]);
  return _assign(_assign({}, validOpts), {
    redirect_uri: redirectUri
  });
};
/**
 * @ignore
 */
var defaultOnRedirectCallback = function defaultOnRedirectCallback(appState) {
  window.history.replaceState({}, document.title, (appState === null || appState === void 0 ? void 0 : appState.returnTo) || window.location.pathname);
};
/**
 * ```jsx
 * <Auth0Provider
 *   domain={domain}
 *   clientId={clientId}
 *   redirectUri={window.location.origin}>
 *   <MyApp />
 * </Auth0Provider>
 * ```
 *
 * Provides the Auth0Context to its child components.
 */
var Auth0Provider = function Auth0Provider(opts) {
  var children = opts.children,
    skipRedirectCallback = opts.skipRedirectCallback,
    _a = opts.onRedirectCallback,
    onRedirectCallback = _a === void 0 ? defaultOnRedirectCallback : _a,
    _b = opts.context,
    context = _b === void 0 ? Auth0Context : _b,
    clientOpts = __rest(opts, ["children", "skipRedirectCallback", "onRedirectCallback", "context"]);
  var client = useState(function () {
    return new Na(toAuth0ClientOptions(clientOpts));
  })[0];
  var _c = useReducer(reducer, initialAuthState),
    state = _c[0],
    dispatch = _c[1];
  var didInitialise = useRef(false);
  useEffect(function () {
    if (didInitialise.current) {
      return;
    }
    didInitialise.current = true;
    (function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var user, appState, error_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              _a.trys.push([0, 7,, 8]);
              user = void 0;
              if (!(hasAuthParams() && !skipRedirectCallback)) return [3 /*break*/, 3];
              return [4 /*yield*/, client.handleRedirectCallback()];
            case 1:
              appState = _a.sent().appState;
              return [4 /*yield*/, client.getUser()];
            case 2:
              user = _a.sent();
              onRedirectCallback(appState, user);
              return [3 /*break*/, 6];
            case 3:
              return [4 /*yield*/, client.checkSession()];
            case 4:
              _a.sent();
              return [4 /*yield*/, client.getUser()];
            case 5:
              user = _a.sent();
              _a.label = 6;
            case 6:
              dispatch({
                type: 'INITIALISED',
                user: user
              });
              return [3 /*break*/, 8];
            case 7:
              error_1 = _a.sent();
              dispatch({
                type: 'ERROR',
                error: loginError(error_1)
              });
              return [3 /*break*/, 8];
            case 8:
              return [2 /*return*/];
          }
        });
      });
    })();
  }, [client, onRedirectCallback, skipRedirectCallback]);
  var buildAuthorizeUrl = useCallback(function (opts) {
    return client.buildAuthorizeUrl(toAuth0LoginRedirectOptions(opts));
  }, [client]);
  var buildLogoutUrl = useCallback(function (opts) {
    return client.buildLogoutUrl(opts);
  }, [client]);
  var loginWithRedirect = useCallback(function (opts) {
    return client.loginWithRedirect(toAuth0LoginRedirectOptions(opts));
  }, [client]);
  var loginWithPopup = useCallback(function (options, config) {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_2, user;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            dispatch({
              type: 'LOGIN_POPUP_STARTED'
            });
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            return [4 /*yield*/, client.loginWithPopup(options, config)];
          case 2:
            _a.sent();
            return [3 /*break*/, 4];
          case 3:
            error_2 = _a.sent();
            dispatch({
              type: 'ERROR',
              error: loginError(error_2)
            });
            return [2 /*return*/];
          case 4:
            return [4 /*yield*/, client.getUser()];
          case 5:
            user = _a.sent();
            dispatch({
              type: 'LOGIN_POPUP_COMPLETE',
              user: user
            });
            return [2 /*return*/];
        }
      });
    });
  }, [client]);
  var logout = useCallback(function (opts) {
    if (opts === void 0) {
      opts = {};
    }
    var maybePromise = client.logout(opts);
    if (opts.localOnly) {
      if (maybePromise && typeof maybePromise.then === 'function') {
        return maybePromise.then(function () {
          return dispatch({
            type: 'LOGOUT'
          });
        });
      }
      dispatch({
        type: 'LOGOUT'
      });
    }
    return maybePromise;
  }, [client]);
  var getAccessTokenSilently = useCallback(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function (opts) {
    return __awaiter(void 0, void 0, void 0, function () {
      var token, error_3, _a;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 2, 3, 5]);
            return [4 /*yield*/, client.getTokenSilently(opts)];
          case 1:
            token = _c.sent();
            return [3 /*break*/, 5];
          case 2:
            error_3 = _c.sent();
            throw tokenError(error_3);
          case 3:
            _a = dispatch;
            _b = {
              type: 'GET_ACCESS_TOKEN_COMPLETE'
            };
            return [4 /*yield*/, client.getUser()];
          case 4:
            _a.apply(void 0, [(_b.user = _c.sent(), _b)]);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/, token];
        }
      });
    });
  }, [client]);
  var getAccessTokenWithPopup = useCallback(function (opts, config) {
    return __awaiter(void 0, void 0, void 0, function () {
      var token, error_4, _a;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 2, 3, 5]);
            return [4 /*yield*/, client.getTokenWithPopup(opts, config)];
          case 1:
            token = _c.sent();
            return [3 /*break*/, 5];
          case 2:
            error_4 = _c.sent();
            throw tokenError(error_4);
          case 3:
            _a = dispatch;
            _b = {
              type: 'GET_ACCESS_TOKEN_COMPLETE'
            };
            return [4 /*yield*/, client.getUser()];
          case 4:
            _a.apply(void 0, [(_b.user = _c.sent(), _b)]);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/, token];
        }
      });
    });
  }, [client]);
  var getIdTokenClaims = useCallback(function (opts) {
    return client.getIdTokenClaims(opts);
  }, [client]);
  var handleRedirectCallback = useCallback(function (url) {
    return __awaiter(void 0, void 0, void 0, function () {
      var error_5, _a;
      var _b;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            _c.trys.push([0, 2, 3, 5]);
            return [4 /*yield*/, client.handleRedirectCallback(url)];
          case 1:
            return [2 /*return*/, _c.sent()];
          case 2:
            error_5 = _c.sent();
            throw tokenError(error_5);
          case 3:
            _a = dispatch;
            _b = {
              type: 'HANDLE_REDIRECT_COMPLETE'
            };
            return [4 /*yield*/, client.getUser()];
          case 4:
            _a.apply(void 0, [(_b.user = _c.sent(), _b)]);
            return [7 /*endfinally*/];
          case 5:
            return [2 /*return*/];
        }
      });
    });
  }, [client]);
  var contextValue = useMemo(function () {
    return _assign(_assign({}, state), {
      buildAuthorizeUrl: buildAuthorizeUrl,
      buildLogoutUrl: buildLogoutUrl,
      getAccessTokenSilently: getAccessTokenSilently,
      getAccessTokenWithPopup: getAccessTokenWithPopup,
      getIdTokenClaims: getIdTokenClaims,
      loginWithRedirect: loginWithRedirect,
      loginWithPopup: loginWithPopup,
      logout: logout,
      handleRedirectCallback: handleRedirectCallback
    });
  }, [state, buildAuthorizeUrl, buildLogoutUrl, getAccessTokenSilently, getAccessTokenWithPopup, getIdTokenClaims, loginWithRedirect, loginWithPopup, logout, handleRedirectCallback]);
  return React.createElement(context.Provider, {
    value: contextValue
  }, children);
};

/**
 * ```js
 * const {
 *   // Auth state:
 *   error,
 *   isAuthenticated,
 *   isLoading,
 *   user,
 *   // Auth methods:
 *   getAccessTokenSilently,
 *   getAccessTokenWithPopup,
 *   getIdTokenClaims,
 *   loginWithRedirect,
 *   loginWithPopup,
 *   logout,
 * } = useAuth0<TUser>();
 * ```
 *
 * Use the `useAuth0` hook in your components to access the auth state and methods.
 *
 * TUser is an optional type param to provide a type to the `user` field.
 */
var useAuth0 = function useAuth0(context) {
  if (context === void 0) {
    context = Auth0Context;
  }
  return useContext(context);
};

/**
 * ```jsx
 * class MyComponent extends Component {
 *   render() {
 *     // Access the auth context from the `auth0` prop
 *     const { user } = this.props.auth0;
 *     return <div>Hello {user.name}!</div>
 *   }
 * }
 * // Wrap your class component in withAuth0
 * export default withAuth0(MyComponent);
 * ```
 *
 * Wrap your class components in this Higher Order Component to give them access to the Auth0Context.
 *
 * Providing a context as the second argument allows you to configure the Auth0Provider the Auth0Context
 * should come from f you have multiple within your application.
 */
var withAuth0 = function withAuth0(Component, context) {
  if (context === void 0) {
    context = Auth0Context;
  }
  return function WithAuth(props) {
    return React.createElement(context.Consumer, null, function (auth) {
      return React.createElement(Component, _assign({}, props, {
        auth0: auth
      }));
    });
  };
};

/**
 * @ignore
 */
var defaultOnRedirecting = function defaultOnRedirecting() {
  return React.createElement(React.Fragment, null);
};
/**
 * @ignore
 */
var defaultReturnTo = function defaultReturnTo() {
  return "".concat(window.location.pathname).concat(window.location.search);
};
/**
 * ```js
 * const MyProtectedComponent = withAuthenticationRequired(MyComponent);
 * ```
 *
 * When you wrap your components in this Higher Order Component and an anonymous user visits your component
 * they will be redirected to the login page and returned to the page they we're redirected from after login.
 */
var withAuthenticationRequired = function withAuthenticationRequired(Component, options) {
  if (options === void 0) {
    options = {};
  }
  return function WithAuthenticationRequired(props) {
    var _this = this;
    var _a = options.returnTo,
      returnTo = _a === void 0 ? defaultReturnTo : _a,
      _b = options.onRedirecting,
      onRedirecting = _b === void 0 ? defaultOnRedirecting : _b,
      _c = options.claimCheck,
      claimCheck = _c === void 0 ? function () {
        return true;
      } : _c,
      loginOptions = options.loginOptions,
      _d = options.context,
      context = _d === void 0 ? Auth0Context : _d;
    var _e = useAuth0(context),
      user = _e.user,
      isAuthenticated = _e.isAuthenticated,
      isLoading = _e.isLoading,
      loginWithRedirect = _e.loginWithRedirect;
    /**
     * The route is authenticated if the user has valid auth and there are no
     * JWT claim mismatches.
     */
    var routeIsAuthenticated = isAuthenticated && claimCheck(user);
    useEffect(function () {
      if (isLoading || routeIsAuthenticated) {
        return;
      }
      var opts = _assign(_assign({}, loginOptions), {
        appState: _assign(_assign({}, loginOptions && loginOptions.appState), {
          returnTo: typeof returnTo === 'function' ? returnTo() : returnTo
        })
      });
      (function () {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4 /*yield*/, loginWithRedirect(opts)];
              case 1:
                _a.sent();
                return [2 /*return*/];
            }
          });
        });
      })();
    }, [isLoading, routeIsAuthenticated, loginWithRedirect, loginOptions, returnTo]);
    return routeIsAuthenticated ? React.createElement(Component, _assign({}, props)) : onRedirecting();
  };
};
export { Auth0Context, Auth0Provider, va as InMemoryCache, ya as LocalStorageCache, OAuthError, Ua as User, initialContext, useAuth0, withAuth0, withAuthenticationRequired };